import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import dayjs from "dayjs";
import { FaPen } from "react-icons/fa";
import { FaCalendarAlt } from "react-icons/fa";
import { Edit3 } from "lucide-react";
import { Sparkles } from "lucide-react";
import { Trash2 } from "lucide-react";
import { Tooltip } from "@mui/material";
import { FaEye } from "react-icons/fa";
import { Plus } from "lucide-react";
import ClearIcon from "@mui/icons-material/Clear";
import { ChevronLeft, ChevronRight } from "lucide-react";
import {
  FileText,
  Search,
  DollarSign,
  Building2,
  CreditCard,
  Users,
  Package,
  TrendingUp,
  TrendingDown,
  Briefcase,
  Home,
  Menu,
  X,
  TicketCheck,
  Landmark,
  HandCoins,
} from "lucide-react";
import VoucherSetupBill from "./VoucherSetupBill";
import { format, set } from "date-fns";
import ic_checkmark from "../utils/ic_checkmark_button.png";
import ic_no_data from "../utils/ic_no_data_to_show.svg";
import ic_timeline_circle_indicator from "../utils/ic_timeline_icon.svg";
import ModifyVoucher from "./ModifyVoucher";
import { useLocation, useNavigate } from "react-router-dom";

import CreditCustomerList from "../components/common/CreditCustomerList";
import Modal from "../components/common/CommonModal";
import { decryptParams } from "../utils/urlCrypto";

const Voucher = () => {
  const DEPARTMENT = localStorage.getItem("currentSelectedDepartment") || "-";
  const [COMPANY_CODE, setCOMPANY_CODE] = useState(
    localStorage.getItem("companyCode"),
  );
  let API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const COMPANY_NAME = API_PATHS[0]?.COMPNAME || "Company";

  // Get VAT percentage from currentUser object
  const currentUserData =
    JSON.parse(localStorage.getItem("currentUser") || "[]")[0] || {};
  const vatPercentage = currentUserData?.vatp || 5; // Default to 5 if not found

  const [selectedVoucherType, setSelectedVoucherType] = useState("JV");
  const [selectedVoucherDescription, setSelectedVoucherDescription] =
    useState("Voucher");

  const [pvnoFromAPI, setPVnoFromAPI] = useState("");
  const [maxVoucherNo, setMaxVoucherNo] = useState("");
  const [disableModify, setDisableModify] = useState(true);
  // const [disableGenerate, setDisableGenerate] = useState(true);
  const [disableGenerate, setDisableGenerate] = useState(false);
  const [voucherTypeList, setVoucherTypeList] = useState([]);
  const [voucherTimeLineList, setVoucherTimeLineList] = useState([]);
  const [jvDate, setJvDate] = useState(new Date().toISOString().split("T")[0]);
  const [jvRecurringDate, setJvRecurringDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [accounts, setAccounts] = useState([]);
  const [voucherModalOpen, setVoucherModalOpen] = useState(false);
  const [searchVoucherAccountTerm, setSearchVoucherAccountTerm] = useState("");
  const [frequency, setFrequency] = useState("");
  const [value, setValue] = useState("ALL");
  const [inputVoucherValue, setInputVoucherValue] = useState("");
  const [inputVoucherValueAccount, setInputVoucherValueAccount] = useState("");
  const [inputVoucherValueDescription, setInputVoucherValueDescription] =
    useState("");
  const [loading, setLoading] = useState(false);
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const [filteredPDCAccounts, setFilteredPDCAccounts] = useState([]);
  const [ty, setTY] = useState([]);
  const [selectedVoucherAccount, setSelectedVoucherAccount] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [dropdownOpenIndex, setDropdownOpenIndex] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedCurrencyRate, setSelectedCurrencyRate] = useState("");
  const [currencies, setCurrencies] = useState([]);
  const [finalAmount, setFinalAmount] = useState(null);

  const [pdcDropdownOpenIndex, setPdcDropdownOpenIndex] = useState(null);
  const [pdcModalOpenIndex, setPdcModalOpenIndex] = useState(null);
  const [pdcHighlightedIndex, setPdcHighlightedIndex] = useState(-1);
  const [pdcSearchTerm, setPdcSearchTerm] = useState("");
  const [pdcModalOpen, setPdcModalOpen] = useState(false);
  const [recurringJournal, setRecurringJournal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSavePopup, setOpenSavePopup] = useState(false);
  const [openModifyPopup, setOpenModifiedPopup] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [openErrorModifySnackbar, setOpenErrorModifySnackbar] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const [isCheckedRepeatAmount, setIsCheckedRepeatAmount] = useState(false);
  const [isCheckedRepeatDesc, setIsCheckedRepeatDesc] = useState(false);
  const [isVatOn, setIsVatOn] = useState(false);
  const [modifyPopup, setModifyPopup] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [modifyVoucherPage, setModifyVoucherPage] = useState(false);
  const [sumOfDebit, setSumOfDebit] = useState(0);
  const [sumOfCredit, setSumOfCredit] = useState(0);
  const [selectedPlan, setSelectedPlan] = useState("daily");
  const [modifyVoucherNo, setModifyVoucherNo] = useState("");

  const [savedVNO, setSavedVNO] = useState("");
  const [modifiedVNO, setModifiedVNO] = useState("");
  const [saving, setSaving] = useState(false);
  const [generatedEntriesState, setGeneratedEntriesState] = useState([]);
  const [modifyUserid, setModifyUserid] = useState("");

  const [docDate, setDocDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  const initialVoucherEntries = [
    {
      companyCode: COMPANY_CODE || localStorage.getItem("companyCode") || "-",
      docDate: "",
      account: "",
      description: "",
      INV: "",
      DESCR: "",
      ty: "D",
      AMOUNT: 0,
      CUR: "",
      rate: 1,
      FCBalAmt: 0,
      credit: 0,
      JOBCODE: "",
      INVDATE: "",
      vatOn: false,
    },
  ];

  useEffect(() => {
    console.log("pdcDropdownOpenIndex:", pdcDropdownOpenIndex);
    console.log("pdcModalOpenIndex:", pdcModalOpenIndex);
  }, [pdcDropdownOpenIndex, pdcModalOpenIndex]);

  // const [entries, setEntries] = useState(initialVoucherEntries);
  const [entries, setEntries] = useState([]);
  const [modifyButton, setModifyButton] = useState(false);
  const [isCorrectLength, setIsCorrectLength] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [selectedAccountsState, setSelectedAccountsState] = useState([]);
  const [setupBillAccount, setSetupBillAccount] = useState("");
  const [isAccountFocused, setIsAccountFocused] = useState(false);
  const [isRecurringInModifyData, setIsRecurringInModifyData] = useState(false);
  const accountRowContainerRef = useRef(null);
  const accountContainerRef = useRef(null);
  const setupBillContainerRef = useRef(null);
  const accountRefs = useRef([]);
  const voucherDropdownRefs = useRef([]);
  const accountNameRefs = useRef([]);
  const invRefs = useRef([]);
  const descriptionRefs = useRef([]);
  const tyRefs = useRef([]);
  const amountRefs = useRef([]);
  const curRefs = useRef([]);
  const rateRefs = useRef([]);
  const fcBalRefs = useRef([]);
  const chqNoRefs = useRef([]);
  const chqDateRefs = useRef([]);
  const reccurringDateRefs = useRef([]);
  const bankRefs = useRef([]);
  const pdcAccRefs = useRef([]);
  const xRefs = useRef([]);
  const jobCodeRefs = useRef([]);
  const cCenterRefs = useRef([]);
  const costCodeRefs = useRef([]);
  const vatAmtRefs = useRef([]);
  const trnRefs = useRef([]);
  const totalRefs = useRef([]);
  const isVatRefs = useRef([]);
  const pdcDropdownRefs = useRef([]);
  const voucherTypeRefs = useRef(null);
  const [comment, setComment] = useState("");

  const difference = (
    Math.round((sumOfCredit - sumOfDebit) * 100) / 100
  ).toFixed(2);
  const isCommentEmpty = !comment.trim();
  const isCreditZero = Number(sumOfCredit) === 0;
  const isDebitZero = Number(sumOfDebit) === 0;
  const isDifferenceZero = Math.round((sumOfCredit - sumOfDebit) * 100) === 0;
  const isAnyAccountEmpty = entries.some((entry) => !entry?.account?.trim());
  const isAnyAmountZero = entries.some(
    (entry) => Number(entry.AMOUNT) === 0 && !entry?.hideshow,
  );
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);

  const location = useLocation();

  const searchParams = new URLSearchParams(location?.search || "");
  const decoded = decryptParams(searchParams.get("t"));

  let modifyVoucherDataFromView = {};

  if (decoded) {
    modifyVoucherDataFromView = {
      modifyVType: decoded?.modifyVType,
      modifyVNO: decoded?.modifyVNO,
      modifyVDate: decoded?.modifyVDate,
      description: decoded?.description || "",
      mode: decoded?.mode,
    };
  } else {
    modifyVoucherDataFromView = location.state?.modifyVoucherData;
  }

  console.log("Modify Vouchur data from view", modifyVoucherDataFromView);
  const [dataFromEdit, setDataFromEdit] = useState(false);

  useEffect(() => {
    fetchVoucherTypeList();
    fetchAccountList("ALL");
    if (accountRefs.current[0]) {
      accountRefs.current[0].focus();
    }
    fetchCurrencyList();
    if (voucherTypeRefs.current) {
      voucherTypeRefs.current.focus();
    }
  }, []);

  const saveValueModifyVoucherDataFromView = (modifyVoucherDataFromView) => {
    console.log("modifyVType from list: ", modifyVoucherDataFromView);
    setSelectedVoucherType(modifyVoucherDataFromView.modifyVType);
    setPVnoFromAPI(modifyVoucherDataFromView.modifyVNO);
    onSubmitVoucherModifyNo(modifyVoucherDataFromView.modifyVNO);
    setJvDate(modifyVoucherDataFromView.modifyVDate);
    setComment(modifyVoucherDataFromView.description || "");
    setDataFromEdit(true);
  };

  useEffect(() => {
    if (modifyVoucherDataFromView) {
      saveValueModifyVoucherDataFromView(modifyVoucherDataFromView);
    }
  }, [modifyVoucherDataFromView, pvnoFromAPI]);

  const isAnyAccountLength = entries.some(
    (entry) => entry.account?.length !== 8,
  );

  const isSelectedAccount = selectedAccountsState.some(
    (state) => state === false,
  );

  useEffect(() => {
    console.log("🚀 ~ Voucher ~ isSelectedAccount:", isSelectedAccount);
  }, [selectedAccountsState]);

  const isDisabled =
    isCommentEmpty ||
    isCreditZero ||
    isDebitZero ||
    !isDifferenceZero ||
    isAnyAccountEmpty ||
    isAnyAccountLength ||
    isSelectedAccount ||
    isAnyAmountZero;

  // const isRecurringDisabled =
  //   isAnyAccountEmpty || !isDifferenceZero || isDebitZero || isCreditZero;
  const isRecurringDisabled = !isDifferenceZero;

  useEffect(() => {
    setSelectedAccountsState((prev) => {
      const newLength = entries.length;
      const updated = [...prev];

      // Extend array if new rows are added
      while (updated.length < newLength) {
        updated.push(false); // default: not selected
      }

      // Trim array if rows were removed
      return updated.slice(0, newLength);
    });
  }, [entries.length]);

  useEffect(() => {
    if (value) {
      fetchAccountList(value);
    }
  }, [value]);

  // Ensure selectedCurrency is initialized once currencies are loaded
  useEffect(() => {
    if (currencies.length > 0 && !selectedCurrency) {
      const defaultCurrency =
        currencies.find((item) => item.rate === 1) || currencies[0];
      setSelectedCurrency(defaultCurrency);
    }
  }, [currencies, selectedCurrency]);

  useEffect(() => {
    setFilteredAccounts(
      searchVoucherAccountTerm
        ? accounts.filter(
            (acc) =>
              acc.ACCOUNT.toLowerCase().includes(
                searchVoucherAccountTerm.toLowerCase(),
              ) ||
              acc.DESCRIPTION.toLowerCase().includes(
                searchVoucherAccountTerm.toLowerCase(),
              ),
          )
        : accounts,
    );
  }, [accounts, searchVoucherAccountTerm]);

  useEffect(() => {
    setFilteredPDCAccounts(
      pdcSearchTerm
        ? accounts?.filter(
            (acc) =>
              acc.ACCOUNT?.toLowerCase().includes(
                pdcSearchTerm.toLowerCase(),
              ) ||
              acc.DESCRIPTION?.toLowerCase().includes(
                pdcSearchTerm.toLowerCase(),
              ),
          )
        : accounts,
    );
  }, [pdcSearchTerm, accounts]);

  useEffect(() => {
    if (selectedVoucherType) {
      fetchVoucherNo();
    }
  }, [selectedVoucherType]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideDropdown = voucherDropdownRefs.current.some(
        (ref) => ref && ref.contains(event.target),
      );
      const clickedInsideAccount = accountRefs.current.some(
        (ref) => ref && ref.contains(event.target),
      );

      if (!clickedInsideDropdown && !clickedInsideAccount) {
        setDropdownOpenIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideDropdown = pdcDropdownRefs.current.some(
        (ref) => ref && ref.contains(event.target),
      );
      const clickedInsideAccount = pdcAccRefs.current.some(
        (ref) => ref && ref.contains(event.target),
      );

      if (!clickedInsideDropdown && !clickedInsideAccount) {
        setPdcDropdownOpenIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fetchVoucherNo = async () => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let apiUrl = `${apiPaths[0]?.API_CONFIG}/api/CRMVoucherSettings/${COMPANY_CODE}/VOUCHERNUMBERS/${DEPARTMENT}/GetNew/${selectedVoucherType}/-`;

    try {
      const response = await axios.get(apiUrl);
      const voucherNo = response.data[0].NEXT_NO;
      setDisableModify(false);
      setPVnoFromAPI(voucherNo || "");
      setMaxVoucherNo(voucherNo || "");

      fetchVoucherTimeline(voucherNo);
    } catch (err) {
      console.error("Error while fetching Voucher No:", err);
    }
  };

  const fetchVoucherTypeList = async () => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let url = `${apiPaths[0]?.API_CONFIG}/api/CRMVoucherSettings/${COMPANY_CODE}/VOUCHERNUMBERS/${DEPARTMENT}/VOUCHER/-/-`;

    try {
      const response = await axios.get(url);
      console.log("responseeee:", response);
      setVoucherTypeList(response.data || []);
    } catch (err) {
      console.error("Error while loading Voucher Type List:", err);
    }
  };

  const fetchVoucherTimeline = async (voucherNo) => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    // let url = `${apiPaths[0]?.API_CONFIG}/api/CRMTaskMainListFilter/${companyCode}/VOUCHERTIMELINE/-/-/${selectedVoucherType}/${pvnoFromAPI}/MAIN/1900-01-01/1900-01-01/-/-/-`;
    let url = `${apiPaths[0]?.API_CONFIG}/api/CRMTaskMainListFilter/${COMPANY_CODE}/VOUCHERTIMELINE/-/-/${selectedVoucherType}/${voucherNo}/${DEPARTMENT}/1900-01-01/1900-01-01/-/-/-`;

    try {
      const response = await axios.get(url);
      console.log("Timeline Data:", response.data);
      setVoucherTimeLineList(response.data || []);
    } catch (err) {
      console.error("Error while loading Voucher Timeline :", err);
    }
  };

  const fetchAccountList = async (valueToAPI) => {
    setLoading(true);
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    // let apiUrl = `${apiPaths[0]?.API_CONFIG}/api/CRMAccountList/${companyCode}/ACCOUNTLIST/${department}/${valueToAPI}/-/-`;
    let apiUrl = `${apiPaths[0]?.API_CONFIG}/api/CRMAccountList/${COMPANY_CODE}/ACCOUNTLIST/${department}/${valueToAPI}/-/-`;

    try {
      const response = await axios.get(apiUrl);
      setAccounts(response.data || []);
    } catch (err) {
      console.error("Error while fetching voucher accounts", err);
    } finally {
      setLoading(false);
    }
  };

  // const handleSelectAccount = (index, selectedAccount) => {
  //   const updatedEntries = [...entries];
  //   updatedEntries[index] = {
  //     ...updatedEntries[index],
  //     account: selectedAccount.ACCOUNT,
  //     description: selectedAccount.DESCRIPTION,
  //   };
  //   setEntries(updatedEntries);
  //   setSelectedVoucherAccount(selectedAccount);
  //   setDropdownOpenIndex(null);
  //   setSearchVoucherAccountTerm("");
  //   setVoucherModalOpen(false);
  // };

  const handleSelectAccount = (rowIndex, acc) => {
    // Update selected account in state
    setSelectedVoucherAccount(acc);

    // Update the row fields
    handleChange(rowIndex, "account", acc.ACCOUNT);
    handleChange(rowIndex, "accdesc", acc.DESCRIPTION);
    handleChange(rowIndex, "description", acc.DESCRIPTION);

    // Mark this row's account as selected (remove red background)
    setSelectedAccountsState((prev) => {
      const updated = [...prev];
      updated[rowIndex] = true;
      return updated;
    });

    // Close modal
    setVoucherModalOpen(false);

    // Reset dropdown highlight states
    setDropdownOpenIndex(null);
    setHighlightedIndex(-1);

    // Focus the next input (INV field or whichever comes next)
    invRefs.current[rowIndex]?.focus();
  };

  const handleAddRow = () => {
    setEntries((prev) => {
      const lastRow = prev.length > 0 ? prev[prev.length - 1] : null;
      setTY((tyPrev) => [...tyPrev, lastRow?.ty === "D" ? "C" : "D"]);
      return [
        ...prev,
        {
          companyCode:
            COMPANY_CODE || localStorage.getItem("companyCode") || "-",
          account: "",
          description: "",
          INV: "",
          DESCR: isCheckedRepeatDesc && lastRow ? lastRow.DESCR : "",
          ty: lastRow?.ty === "D" ? "C" : "D",
          AMOUNT: isCheckedRepeatAmount && lastRow ? lastRow.AMOUNT : 0,
          CUR: (selectedCurrency || currencies[0])?.curno || "",
          rate: (selectedCurrency || currencies[0])?.rate || 1,
          FCBalAmt: 0,
          chqNo: "",
          chqDate: "",
          docDate: "",
          Bank: "",
          pdcAcc: "",
          x: "",
          JOBCODE: "",
          vatAmt: "",
          total: "",
          trn: "",
        },
      ];
    });

    setTimeout(() => {
      // wait until new row is rendered
      const lastIndex = accountRefs.current.length - 1;
      accountRefs.current[lastIndex]?.focus(); // focus new row's first input
    }, 0);
  };

  // const handleChange = (index, field, value) => {
  //   const newEntries = [...entries];
  //   newEntries[index][field] = field === "account" ? value : value || "";
  //   setEntries(newEntries);
  //   if (field === "account") {
  //     setSearchVoucherAccountTerm(value);
  //     setDropdownOpenIndex(index);
  //   }
  // };

  // const handleChange = (index, field, value) => {
  //   setEntries((prevEntries) => {
  //     const updatedEntries = [...prevEntries];
  //     const updatedRow = { ...updatedEntries[index], [field]: value || "" };
  //     updatedEntries[index] = updatedRow;
  //     return updatedEntries;
  //   });

  //   if (field === "account") {
  //     setSearchVoucherAccountTerm(value);
  //     setDropdownOpenIndex(index);
  //   }
  // };

  const handleChange = (index, field, value) => {
    setEntries((prevEntries) => {
      const updatedEntries = [...prevEntries];

      // Sync both INV and ref fields
      if (field === "INV") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          INV: value || "",
          ref: value || "", // Keep ref in sync for API
        };
      } else if (field === "account") {
        // const trimmedValue = value.trim();

        const matchedAccount = filteredAccounts?.find(
          (acc) =>
            acc.account?.toLowerCase() === value?.toLowerCase() ||
            acc.description?.toLowerCase() === value?.toLowerCase(),
        );

        setSetupBillAccount(matchedAccount ? matchedAccount.ACCOUNT : value);
        updatedEntries[index] = {
          ...updatedEntries[index],
          account: matchedAccount ? matchedAccount.ACCOUNT : value || "",
        };
      } else if (field === "accdesc") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          accdesc: value || "",
          description: value || "", // Keep ref in sync for API
        };
      } else if (field === "DESCR") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          LPONO: value || "",
          DESCR: value || "",
        };
      } else if (field === "AMOUNT") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          AMOUNT: value || "",
          amount: value || "",
        };
      } else if (field === "chqDate") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          chqDate: value || "",
          chqdate: value || "",
        };
      } else if (field === "chqNo") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          chqNo: value || "",
          chqno: value || "",
        };
      } else if (field === "Bank") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          Bank: value || "",
          bank: value || "",
        };
      } else if (field === "pdcAcc") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          pdcAcc: value || "",
          pdc_acc: value || "",
        };
      } else if (field === "JOBCODE") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          JOBCODE: value || "",
          job_code: value || "",
        };
      } else if (field === "costCode") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          costCode: value || "",
          COSTCODE: value || "",
        };
      } else if (field === "CCENTER") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          CCENTER: value || "",
          ccno: value || "",
        };
      } else if (field === "trn") {
        updatedEntries[index] = {
          ...updatedEntries[index],
          ttref: value || "",
          trn: value || "",
        };
      } else {
        updatedEntries[index] = {
          ...updatedEntries[index],
          [field]: value || "",
        };
      }

      return updatedEntries;
    });

    if (field === "account") {
      setSearchVoucherAccountTerm(value);
      setDropdownOpenIndex(index);
    }
  };

  const handleChangePdcAcc = (index, field, value) => {
    setEntries((prevEntries) => {
      const newEntries = [...prevEntries];
      if (!newEntries[index]) return prevEntries;
      newEntries[index][field] = field === "pdcAcc" ? value : value || "";
      if (field === "pdcAcc") {
        setPdcSearchTerm(value);
      }
      return newEntries;
    });
  };

  // const handleChangeAmountEntry = (index, field, value) => {
  //   console.log(
  //     "🚀 ~ handleChangeAmountEntry ~ handleChangeAmountEntry is called:"
  //   );

  //   setEntries((prevEntries) => {
  //     const updated = [...prevEntries];
  //     const amount = parseFloat(value) || 0;
  //     const rate = parseFloat(selectedCurrencyRate) || 1; // ✅ use global state

  //     updated[index].AMOUNT = amount;
  //     updated[index].FCBalAmt = Number(amount / rate).toFixed(2); // ✅ proper math

  //     return updated;
  //     // updated[index] = {
  //     //   ...updated[index],
  //     //   amount: parseFloat(value) || 0,
  //     //   AMOUNT: parseFloat(value) || 0,
  //     // };
  //     // return updated;
  //   });
  // };

  const handleChangeAmountEntry = (index, field, value) => {
    setEntries((prevEntries) => {
      const updated = [...prevEntries];
      const amount = parseFloat(value) || 0;
      const rate = parseFloat(updated[index].rate) || 1;

      updated[index] = {
        ...updated[index],
        AMOUNT: amount,
        FCBalAmt: Number(amount / rate).toFixed(2),
      };
      return updated;
    });
  };

  const handleChangeAmountModify = (index, field, value) => {
    setEntries((prevEntries) => {
      const updated = [...prevEntries];
      const amount = parseFloat(value) || 0;
      const rate = parseFloat(updated[index].rate) || 1;

      updated[index] = {
        ...updated[index],
        amount: amount,
        AMOUNT: amount,
        FCBalAmt: Number(amount / rate).toFixed(2),
      };
      return updated;
    });
  };

  // const handleChangeAmountModify = (index, field, value) => {
  //   console.log(
  //     "🚀 ~ handleChangeAmountModify ~ handleChangeAmountModify is called:"
  //   );

  //   setEntries((prevEntries) => {
  //     const updated = [...prevEntries];
  //     // const amount = parseFloat(value) || 0;
  //     // const rate = parseFloat(selectedCurrencyRate) || 1; // ✅ use global state

  //     // updated[index].AMOUNT = amount;
  //     // updated[index].FCBalAmt = Number(amount / rate).toFixed(2); // ✅ proper math

  //     // return updated;
  //     updated[index] = {
  //       ...updated[index],
  //       amount: parseFloat(value) || 0,
  //       AMOUNT: parseFloat(value) || 0,
  //     };
  //     return updated;
  //   });
  // };

  const handleChangeFCBalAmt = (index, value) => {
    setEntries((prevEntries) => {
      const updated = [...prevEntries];
      const fcBalAmt = parseFloat(value) || 0;
      const rate = parseFloat(updated[index].rate) || 1;

      updated[index] = {
        ...updated[index],
        FCBalAmt: fcBalAmt,
        curamount: fcBalAmt,
        AMOUNT: Number(fcBalAmt * rate).toFixed(2),
      };
      return updated;
    });
  };

  // const handleChangeFCBalAmt = (index, value) => {
  //   setEntries((prevEntries) => {
  //     const updated = [...prevEntries];
  //     const fcBalAmt = parseFloat(value) || 0;
  //     const rate = parseFloat(selectedCurrencyRate) || 1; // ✅ use global state

  //     updated[index].FCBalAmt = fcBalAmt;
  //     updated[index].AMOUNT = Number(fcBalAmt * rate).toFixed(2); // ✅ reverse math

  //     return updated;
  //   });
  // };

  const handleChangeRate = (index, value) => {
    setEntries((prevEntries) => {
      const updated = [...prevEntries];
      const rate = parseFloat(value) || 1;
      const fcBalAmt = parseFloat(updated[index].FCBalAmt) || 0;

      updated[index] = {
        ...updated[index],
        rate,
        AMOUNT: Number(fcBalAmt * rate).toFixed(2),
      };
      return updated;
    });
  };

  const handleTyData = (index) => {
    setTY((prev) =>
      prev.map((value, i) =>
        i === index ? (value === "D" ? "C" : "D") : value,
      ),
    );
    setEntries((prevEntries) => {
      const newEntries = [...prevEntries];
      newEntries[index] = {
        ...newEntries[index],
        ty: newEntries[index].ty === "C" ? "D" : "C",
      };
      return newEntries;
    });

    setTimeout(() => {
      // wait until new row is rendered
      // const lastIndex = amountRefs.current.length - 1;
      const lastIndex = amountRefs.current.length;
      amountRefs.current[lastIndex]?.focus(); // focus new row's first input
    }, 0);
    // amountRefs.current[index + 1]?.focus();
  };

  const onDataToRecieve = (data) => {
    const transferType = selectedVoucherType?.startsWith("PV") ? "D" : "C";
    console.log("Recieved Data From Setup bill:", data);
    const newEntries = data.map((item) => ({
      account: selectedVoucherAccount?.ACCOUNT || "",
      description: selectedVoucherAccount?.DESCRIPTION || "",
      accdesc: selectedVoucherAccount?.DESCRIPTION || "",
      INV: item.INV || "",
      ref: item.INV || "",
      DESCR: item.DESCR || "",
      LPONO: item.DESCR || "",
      ty: transferType,
      type: transferType,
      AMOUNT: item.AMOUNT || 0,
      amount: item.AMOUNT || 0,
      CUR: item.CUR || "",
      curno: item.CUR || "",
      rate: item.rate || 1,
      FCBalAmt: item.BALAMT || 0,
      chqNo: "",
      chqno: "",
      chqDate: "", //item.INVDATE
      chqdate: "", //item.INVDATE
      Bank: "",
      bank: "",
      pdcAcc: "",
      pdc_acc: "",
      x: "",
      JOBCODE: item.JOBCODE || "",
      job_code: item.JOBCODE || "",
      vatAmt: "",
      total: "",
      trn: "",
      ttref: "",
      ccno: "",
      COSTCODE: "",
      costCode: "",
      status: "",
    }));
    setEntries((prev) => {
      const validPrev = prev.filter(
        (entry) =>
          entry?.INV ||
          entry?.ref ||
          Number(entry?.AMOUNT || entry?.amount) > 0,
      );
      return [...validPrev, ...newEntries];
    });

    setSelectedAccountsState((prev) => {
      const updated = [...prev];
      for (let i = 0; i < newEntries.length; i++) {
        updated.push(true);
      }
      return updated;
    });

    setIsChecked(false);
  };

  const types = [
    { name: "All", icon: Home },
    { name: "Cash", icon: DollarSign },
    { name: "Bank", icon: Landmark },
    { name: "PDC", icon: TicketCheck },
    { name: "Customers", icon: Users },
    { name: "Suppliers", icon: Package },
    { name: "Assets", icon: Briefcase },
    { name: "Liabilities", icon: CreditCard },
    { name: "Income", icon: TrendingUp },
    { name: "Expenses", icon: TrendingDown },
    { name: "InExpenses", icon: HandCoins },
    { name: "InterCompany", icon: Building2, disable: false },
  ];

  const formatBalance = (balance) =>
    new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(balance);

  const totalDebit = entries.reduce((sum, row) => {
    if (row?.ty === "D") {
      const amount = Number(row.AMOUNT) || 0;
      const vatAmount = row?.vatOn ? amount * (vatPercentage / 100) : 0;
      return sum + amount + vatAmount;
    }
    return sum;
  }, 0);
  const totalCredit = entries.reduce((sum, row) => {
    if (row?.ty === "C") {
      const amount = Number(row.amount ?? row.AMOUNT) || 0;
      const vatAmount = row?.vatOn ? amount * (vatPercentage / 100) : 0;
      return sum + amount + vatAmount;
    }
    return sum;
  }, 0);

  //   const totalCredit = entries.reduce(
  //   (sum, row) => sum + (row.ty === "C" ? Number(row.amount ?? row.AMOUNT || 0) : 0),
  //   0
  // );

  useEffect(() => {
    setSumOfDebit(Math.round(totalDebit * 100) / 100);
    setSumOfCredit(Math.round(totalCredit * 100) / 100);
    console.log("Entries:", entries);
    console.log(
      "Entries:",
      entries.filter((entry) => entry?.selected),
    );

    // console.log(
    //   "Total Debit:",
    //   totalDebit.toFixed(2),
    //   "Total Credit:",
    //   totalCredit.toFixed(2)
    // );
  }, [entries]);

  const handleVatToggle = (index, checked) => {
    const updatedEntries = [...entries];
    updatedEntries[index].vatOn = checked;
    setEntries(updatedEntries);
  };

  const handleDropdownSelectAccount = (rowIndex, acc) => {
    setSelectedVoucherAccount(acc);
    handleChange(rowIndex, "account", acc.ACCOUNT);
    handleChange(rowIndex, "accdesc", acc.DESCRIPTION);
    handleChange(rowIndex, "description", acc.DESCRIPTION);
    setDropdownOpenIndex(null);
    setHighlightedIndex(-1);
    invRefs.current[rowIndex]?.focus(); // focus reference input

    setSelectedAccountsState((prev) => {
      const updated = [...prev];
      updated[rowIndex] = true;
      return updated;
    });
  };

  useEffect(() => {
    console.log("selectedAccountsState:", selectedAccountsState);
    const isCorrectAcclen = entries.some(
      (entry) => entry?.account.length === 8,
    );

    setIsCorrectLength(isCorrectAcclen);
    console.log("🚀 ~ Voucher ~ isAccountNotlength:", isCorrectAcclen);
    const currentEntries = entries.map((entry) => entry?.account);
    console.log("🚀 ~ Voucher ~ currentEntries:", currentEntries);

    // isCommentEmpty
    console.log("🚀 ~ Voucher ~ isCommentEmpty:", isCommentEmpty);
    // isCreditZero
    console.log("🚀 ~ Voucher ~ isCreditZero:", isCreditZero);
    // isDebitZero
    console.log("🚀 ~ Voucher ~ isDebitZero:", isDebitZero);
    // isDifferenceZero
    console.log("🚀 ~ Voucher ~ isDifferenceZero:", isDifferenceZero);
    // isAnyAccountEmpty
    console.log("🚀 ~ Voucher ~ isAnyAccountEmpty:", isAnyAccountEmpty);
    // isAnyAccountLength
    console.log("🚀 ~ Voucher ~ isAnyAccountLength:", isAnyAccountLength);
  }, [selectedAccountsState]);

  const requestCurrencyList = async ({ url, method, timeout }) => {
    return axios({
      url,
      method,
      timeout,
    }).then((res) => res.data);
  };

  const fetchCurrencyList = async () => {
    let company_code_from_local_storage = COMPANY_CODE;

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    const url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/CURRENCY/-/-`;

    try {
      const response = await requestCurrencyList({
        url: url,
        method: "GET",
        timeout: 10000,
      });

      // console.log("Response", response);
      setCurrencies(response || []);

      // Default currency from the fetched data - use first item
      if (response && response.length > 0) {
        const defaultCurrency =
          response?.find((item) => item?.rate === 1) || response[0];
        setSelectedCurrency(defaultCurrency);
      }
    } catch (err) {
      console.error("Error loading data:", err);
      setCurrencies([]);
    }
  };

  // useEffect(() => {
  //   setSelectedCurrencyRate(selectedCurrency?.rate?.toFixed(6));
  // }, [selectedCurrency]);

  // setFinalAmount(e.target.value)

  const handleDropdownSelectPdcAccount = (index, selectedAcc) => {
    handleChangePdcAcc(index, "pdcAcc", selectedAcc?.ACCOUNT || "");
    handleChange(index, "Bank", selectedAcc?.DESCRIPTION || "");
    handleChange(index, "description", selectedAcc?.DESCRIPTION || "");
    // setPdcDropdownOpenIndex(null);
  };

  // filteredPDCAccounts
  // console.log(" ~ Voucher ~ filteredPDCAccounts:", filteredPDCAccounts);

  const onRecurringJournal = () => {
    setRecurringJournal((prev) => !prev);
  };

  const cleanDate = (date) => {
    if (!date) return null;
    if (date.startsWith("1900") || date.includes("1900-01-01")) return null;
    return date.split("T")[0].split(" ")[0];
  };

  const onSaveVoucher = async () => {
    let company_code_from_local_storage = COMPANY_CODE;

    let currentSelectedDepartment_from_local_storage = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let currentUser_from_local_storage = localStorage.getItem("currentUser")
      ? localStorage.getItem("currentUser")
      : "-";

    const user_from_local_storage = currentUser_from_local_storage?.user;
    // const salesman_from_local_storage =  currentUser_from_local_storage?.sales_man

    const buildJVPayload = () => {
      let currentUser_from_local_storage = localStorage.getItem("currentUser")
        ? localStorage.getItem("currentUser")
        : "-";

      const user_from_local_storage = JSON.parse(
        localStorage.getItem("currentUser") || "[]",
      )[0]?.user;
      console.log(user_from_local_storage); // "ADMIN"

      console.log("entries while saving voucher:", entries);
      const journalVoucherEntry = entries.map((row) => ({
        cmpcode: company_code_from_local_storage,

        operation: "ENTRY",
        JVTYPE: selectedVoucherType || "",
        TYPE_NO: pvnoFromAPI || "0",
        JVDATE: jvDate || null,
        CUST_ACC: row.account.trim() || "0",
        ACCDESC: row.description || "",
        AMOUNT: row.AMOUNT + "" || "0",
        DESCRIPT: row.DESCR || "",
        // DEPTNO: currentSelectedDepartment_from_local_storage || "",
        DEPTNO: DEPARTMENT || "",
        COMMENTS: comment || "",
        USERID: row.account.trim() || "0",
        job_code: row.JOBCODE || "",
        sman_code: "",
        costc: row.costCode || "",
        chqno: row.chqNo || "",
        chqdate: row.chqDate || null,
        rate:
          (row.rate || (selectedCurrency || currencies[0])?.rate) + "" || "1",
        pdcstatus: "",
        pdc_acc: row.pdcAcc || "0",
        reason: "",
        account: row.account.trim() || "0",
        jvnum: pvnoFromAPI || "0",
        ref: row.INV || "",
        entry_ref: row.DESCR || "",
        type: row.ty || "",
        curno:
          row.curno ||
          row.CUR ||
          (selectedCurrency || currencies[0])?.curno ||
          "AED",
        // curamount: row?.curamount || row?.FCBalAmt ,
        curamount: row?.curamount ? row?.curamount : 0,
        user_id: user_from_local_storage?.trim() || "",
        accountype: row.ty === "D" ? "1" : "2" || "0",
        depn_p: "0",
        status1: "",
        status: row.status || "",
        appl_amt1: "0",
        appl_amt: "0",
        bank: row.Bank || "",
        due_date: null,
        // doc_date: jvRecurringDate || null,
        doc_date:
          generatedEntriesState?.length > 0
            ? row.docDate
            : jvRecurringDate || null,
        month: row.ty === "D" ? "1" : "2" || "0",
        lpono: "",
        chqprn: "",
        inv_amt: "0",
        inv_fcamt: "0",
        inv_fc: "",
        ccno: row.CCENTER || "",
        ttref: row.trn || "",
        appl_cramt: "0",
        appl_crop: "0",
        appl_dramt: "0",
        pgroup: recurringJournal ? "R" : "",
        upd: "",
        v_amt: row.vatOn
          ? Number(row.AMOUNT * (vatPercentage / 100)).toFixed(2)
          : "0",
        COSTCODE: row.vatOn ? "VAT" : "",
      }));

      return journalVoucherEntry;
    };

    const finalJVload = buildJVPayload();

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMRVPVReg`;
    setSaving(true);
    try {
      const response = await axios.post(apiUrl, finalJVload, config);

      console.log("Receipt data Saved:", response.data);
      const data = response?.data;
      setSavedVNO(data?.vno);

      // setReceiptSavedPopup(true);

      setOpenSavePopup(true);
      // setOpenSnackbar(true);
      setEntries(initialVoucherEntries);
      setDataFromEdit(false);
    } catch (error) {
      console.log("error while saving reciept", error);
      setOpenErrorSnackbar(true);
    } finally {
      setSaving(false);
    }
  };
  const onModifyVoucher = async () => {
    let company_code_from_local_storage = COMPANY_CODE;

    let currentSelectedDepartment_from_local_storage = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let currentUser_from_local_storage = localStorage.getItem("currentUser")
      ? localStorage.getItem("currentUser")
      : "-";

    const user_from_local_storage = currentUser_from_local_storage?.user;
    // const salesman_from_local_storage =  currentUser_from_local_storage?.sales_man

    let mainEntryType = null;

    if (selectedVoucherType?.startsWith("PV")) {
      mainEntryType = "D";
    } else if (selectedVoucherType?.startsWith("RV")) {
      mainEntryType = "C";
    }

    const buildJVPayload = () => {
      let currentUser_from_local_storage = localStorage.getItem("currentUser")
        ? localStorage.getItem("currentUser")
        : "-";

      const user_from_local_storage = JSON.parse(
        localStorage.getItem("currentUser") || "[]",
      )[0]?.user;
      const useridToUse = modifyUserid || "";
      // console.log(user_from_local_storage); // "ADMIN"
      console.log("entries while modifying voucher:", entries);
      const mainEntry = mainEntryType
        ? entries.find((row) => row.type === mainEntryType)
        : null;

      const mainAccount = mainEntry?.account?.trim() || "0";

      const journalVoucherEntry = entries.map((row) => ({
        // row.chqdate
        // console.log(row.chqdate)
        cmpcode: company_code_from_local_storage,

        operation: "EDIT",
        JVTYPE: selectedVoucherType || "",
        TYPE_NO: pvnoFromAPI || "0",
        JVDATE: jvDate || null,
        CUST_ACC: mainAccount || "0",
        ACCDESC: row.accdesc || "",
        AMOUNT: row.amount + "" || "0",
        DESCRIPT: row.DESCR || "",
        // DEPTNO: currentSelectedDepartment_from_local_storage || "",
        DEPTNO: DEPARTMENT,
        COMMENTS: comment || "",
        USERID: useridToUse,
        job_code: row.job_code || "",
        sman_code: "",
        costc: row.COSTCODE || "",
        chqno: row.chqno || "",
        // chqdate: row.chqdate || null,
        chqdate: cleanDate(row.chqdate),
        rate:
          (row.rate || (selectedCurrency || currencies[0])?.rate) + "" || "1",
        pdcstatus: "",
        pdc_acc: row.pdc_acc || "0",
        reason: "",
        account: row.account.trim() || "0",
        jvnum: pvnoFromAPI || "0",
        ref: row.ref || "",
        entry_ref: row.DESCR || "",
        type: row.ty || "",
        curno:
          row.curno ||
          row.CUR ||
          (selectedCurrency || currencies[0])?.curno ||
          "AED",
        // curamount: row?.curamount || row?.FCBalAmt,
        curamount: row?.curamount ? row?.curamount : 0,
        user_id: user_from_local_storage?.trim() || "",
        // accountype: row.type || "",
        accountype: row.ty === "D" ? "1" : "2" || "0",
        depn_p: "0",
        status1: "",
        status: "",
        appl_amt1: "0",
        appl_amt: "0",
        bank: row.bank || "",
        due_date: null,
        // doc_date: row.reccurringDate || null,
        // doc_date: jvRecurringDate || null,
        doc_date:
          generatedEntriesState?.length > 0
            ? row.docDate
            : jvRecurringDate || null,

        month: row.ty === "D" ? "1" : "2" || "0",
        lpono: "",
        chqprn: "",
        inv_amt: "0",
        inv_fcamt: "0",
        inv_fc: "",
        ccno: row.ccno || "",
        ttref: row.ttref || "",
        appl_cramt: "0",
        appl_crop: "0",
        appl_dramt: "0",
        pgroup: "",
        upd: "",
        v_amt: row.vatOn
          ? Number(row.amount * (vatPercentage / 100)).toFixed(2)
          : "0",
        COSTCODE: row.vatOn ? "VAT" : "",
      }));

      return journalVoucherEntry;
    };

    const finalJVload = buildJVPayload();
    console.log("JV Payload being sent:", finalJVload);
    // return;
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMRVPVReg`;
    setSaving(true);
    try {
      const response = await axios.post(apiUrl, finalJVload, config);

      console.log("Voucher data Modified:", response.data);
      const data = response?.data;
      setModifiedVNO(data?.vno);
      // setReceiptSavedPopup(true);
      // setOpenSavePopup(true);

      setOpenModifiedPopup(true);
      // fetchVoucherTimeline(pvnoFromAPI);
      // setOpenSnackbar(true);
    } catch (error) {
      console.log("error while saving reciept", error);
      setOpenErrorModifySnackbar(true);
    } finally {
      setSaving(false);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSavePopup(false);
    setOpenModifiedPopup(false);

    setOpenErrorSnackbar(false);
    setOpenErrorModifySnackbar(false);
    // setOpenSnackbar(false);

    window.location.reload();
  };

  const onModify = () => {
    setPdcDropdownOpenIndex(null);
    setModifyPopup(true);
  };

  const onGenerate = () => {
    console.log("Generate clicked");
    console.log("frequency:", frequency);
    console.log("jvRecurringDate:", jvRecurringDate);
    console.log("plan:", selectedPlan);
    console.log("entries:", entries);

    let repeatCount = 1;

    if (selectedPlan === "daily") repeatCount = Number(frequency);
    else if (selectedPlan === "monthly") repeatCount = Number(frequency);
    else if (selectedPlan === "yearly") repeatCount = Number(frequency);
    else repeatCount = Number(frequency) || 1;

    const generatedEntries = Array.from({ length: repeatCount }, (_, i) =>
      entries.map((entry) => {
        const rawDate =
          selectedPlan === "daily"
            ? new Date(
                new Date(jvRecurringDate).setDate(
                  new Date(jvRecurringDate).getDate() + i,
                ),
              )
            : selectedPlan === "monthly"
              ? new Date(
                  new Date(jvRecurringDate).setMonth(
                    new Date(jvRecurringDate).getMonth() + i,
                  ),
                )
              : selectedPlan === "yearly"
                ? new Date(
                    new Date(jvRecurringDate).setFullYear(
                      new Date(jvRecurringDate).getFullYear() + i,
                    ),
                  )
                : new Date(jvRecurringDate);

        // Format as DD/MM/YYYY
        // const formattedDate = rawDate.toLocaleDateString("en-GB");
        const formattedDate = rawDate.toISOString().split("T")[0]; // YYYY-MM-DD

        return {
          ...entry,
          docDate: formattedDate,
        };
      }),
    ).flat();

    console.log("Generated entries:", generatedEntries);
    setGeneratedEntriesState(generatedEntries);
    setEntries(generatedEntries);
    setSelectedAccountsState(Array(generatedEntries.length).fill(true));
    setDisableGenerate(true);
  };

  const onNew = () => {
    // modifyVoucherNoFromView('')
    setPdcDropdownOpenIndex(null);
    // setModifyPopup(true);
    setModifyButton(false);
    setEntries(initialVoucherEntries);
    setPVnoFromAPI("");
    // handleVoucherTypeChange('JV')
    fetchVoucherNo();
    // window.location.reload();
    // navigate("/voucher", { replace: true });
    navigate("/voucher");
  };
  const onDelete = () => {
    setPdcDropdownOpenIndex(null);
    // window.location.reload();
    setDeletePopup(true);
  };

  const onSubmitVoucherDeleteNo = async (deleteVoucherNo) => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
  };

  const onModifyClose = () => {
    setModifyPopup(false);
  };

  const navigate = useNavigate();

  const onSubmitVoucherModifyNo = (newVNO) => {
    setModifyPopup(false);
    setPVnoFromAPI(newVNO);
    // setModifyVoucherNo("")
    // setModifyVoucherPage(true);
    fetchModifyVNoData(newVNO);
    setModifyButton(true);
  };

  const fetchModifyVNoData = async (newVNO) => {
    let company_code_from_local_storage = COMPANY_CODE;

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiURL = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMDocTransfer/${COMPANY_CODE}/VOUCHERMODIFY/${selectedVoucherType}/-/-/${DEPARTMENT}/${newVNO}/-`;

    try {
      const response = await axios.get(apiURL);
      const apiData = response.data;
      console.log(" ~ fetchModifyVNoData ~ apiData:", apiData);
      if (apiData?.length > 0 && apiData[0]?.userid) {
        setModifyUserid(apiData[0].userid);
      }
      // Map API fields to expected format
      const mappedData = apiData.map((row) => ({
        ...row,
        INV: row.ref || row.INV || "", // Ensure INV has the ref value
        DESCR: row.DESCR || row.entry_ref || row.description || "",
        AMOUNT: row.AMOUNT || row.amount || 0,
        ty: row.type || row.accountype || row.ty || "D",
        account: row.CUST_ACC || row.account || "",
        description: row.ACCDESC || row.description || "",
        // Add other mappings as needed
        chqNo: row.chqno || row.chqNo || "",
        chqno: row.chqno || row.chqNo || "",
        chqDate: row.chqdate || row.chqDate || "",
        chqdate: row.chqdate || row.chqDate || "",
        JOBCODE: row.job_code || row.JOBCODE || "",
        jvDate: new Date(row.jvdate).toISOString().split("T")[0],
        // Enable VAT toggle if v_amt has a value greater than 0
        vatOn: row.v_amt && Number(row.v_amt) > 0 ? true : false,
        // ... map all other fields
      }));

      console.log("🚀 Mapped Data:", mappedData);
      console.log("🚀 Voucher number changed data :", mappedData);
      const isRecurInModData = mappedData.some((data) => data.pgroup === "R");
      setIsRecurringInModifyData(isRecurInModData);
      setSelectedAccountsState((prev) => {
        const updated = [...prev];
        for (let i = 0; i < mappedData.length; i++) {
          updated[i] = true;
        }
        return updated;
      });
      setEntries(mappedData);
      // setModifyButton(true);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    console.log("🚀 ~ Voucher ~ modifyVoucherNo:", modifyVoucherNo);
  }, [modifyVoucherNo]);

  const onVoucherView = () => {
    navigate("/voucherView");
  };

  // const handleCurrencyChange = (index, value) => {
  //   const selected = currencies.find((cur) => cur.curno === value);
  //   setSelectedCurrencyRate(selected.rate);
  //   // console.log("🚀 ~ handleCurrencyChange ~ selected:", selected);

  //   setEntries((prev) => {
  //     const updated = [...prev];
  //     updated[index] = {
  //       ...updated[index],
  //       curno: selected.curno,
  //       rate: selected.rate,
  //     };
  //     return updated;
  //   });
  // };

  const handleCurrencyChange = (index, value) => {
    const selected = currencies.find((cur) => cur.curno === value);
    const rate = parseFloat(selected?.rate) || 1;

    setEntries((prev) => {
      const updated = [...prev];
      const current = updated[index];

      const amount = parseFloat(current.AMOUNT) || 0;
      const fcBalAmt = parseFloat(current.FCBalAmt) || 0;

      updated[index] = {
        ...current,
        curno: selected.curno,
        rate,
        AMOUNT: amount
          ? Number(amount).toFixed(2)
          : Number(fcBalAmt * rate).toFixed(2),
        FCBalAmt: fcBalAmt
          ? Number(fcBalAmt).toFixed(2)
          : Number(amount / rate).toFixed(2),
      };
      return updated;
    });
  };

  //   const handleCurrencyChange = (index, value) => {
  //   const selected = currencies.find((cur) => cur.curno === value);
  //   if (!selected) return;

  //   const rate = parseFloat(selected.rate) || 1;

  //   setEntries((prev) => {
  //     const updated = [...prev];
  //     const currentAmount = parseFloat(updated[index].AMOUNT || updated[index].amount || 0);

  //     updated[index] = {
  //       ...updated[index],
  //       curno: selected.curno,
  //       rate: rate,
  //       FCBalAmt: (currentAmount / rate).toFixed(2), // ✅ update foreign amount
  //     };

  //     return updated;
  //   });

  //   // Update global selected rate state (if you’re using it elsewhere)
  //   setSelectedCurrencyRate(rate);
  // };

  const handleVoucherTypeChange = (e) => {
    const value = e.target.value;
    const selectedVoucher = voucherTypeList.find(
      (voucher) => voucher.VTYPE === value,
    );

    setSelectedVoucherType(value);
    setSelectedVoucherDescription(selectedVoucher?.VDESCRIPTION || "");
  };

  const [isSelectedItemCodeCorrect, setIsSelectedItemCodeCorrect] =
    useState(false);

  useEffect(() => {
    if (setupBillAccount) {
      console.log("🚀 ~ Voucher ~ setupBillAccount:", setupBillAccount);

      setIsAccountFocused(true);
    }
  }, [setupBillAccount]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // if (
      //   accountContainerRef.current &&
      //   !accountContainerRef.current.contains(event.target) &&
      //   !setupBillContainerRef.current.contains(event.target)
      // ) {
      //   setSetupBillAccount("");
      //   setIsAccountFocused(false);
      // }
      if (
        accountRowContainerRef.current &&
        !accountRowContainerRef.current.contains(event.target) &&
        !setupBillContainerRef.current.contains(event.target)
      ) {
        setSetupBillAccount("");
        setIsAccountFocused(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (frequency.length > 0) {
      setDisableGenerate(false);
    } else {
      // setDisableGenerate(true);
    }
  }, [frequency]);

  const handleVoucherChange = (direction) => {
    setRecurringJournal(false);

    if (!pvnoFromAPI) return;

    const currentNo = Number(pvnoFromAPI) || 0;
    // Assuming maxVoucherNo is available or passed as a prop/state
    const maxNo = Number(maxVoucherNo) || currentNo; // Use actual max voucher number
    let newNo = currentNo;

    if (direction === "next") {
      if (currentNo < maxNo) {
        newNo = currentNo + 1;
      } else {
        return; // At latest voucher
      }
    } else if (direction === "prev") {
      if (currentNo > 1) {
        newNo = currentNo - 1;
      } else {
        return; // At first voucher
      }
    } else {
      return; // Invalid direction
    }

    setPVnoFromAPI(String(newNo));
    fetchModifyVNoData(newNo);
    fetchVoucherTimeline(newNo);
  };

  const handleAddRowRef = useRef();
  handleAddRowRef.current = handleAddRow;

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.altKey && e.key.toLowerCase() === "a") {
        e.preventDefault();
        console.log(" Alt/Option + A pressed!");
        handleAddRowRef.current?.();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleVoucherAccountSelect = (data) => {
    // console.log(" voucher data from modal:", data);

    handleSelectAccount(selectedRowIndex, data);
  };

  const handlePDCAccountSelect = (data) => {
    handleChange(pdcModalOpenIndex, "pdcAcc", data?.ACCOUNT);
    handleChange(pdcModalOpenIndex, "Bank", data?.DESCRIPTION || "");
    handleChange(pdcModalOpenIndex, "description", data?.DESCRIPTION || "");
    setPdcDropdownOpenIndex(null);
    setPdcModalOpen(false);
    setTimeout(() => {
      pdcAccRefs.current[pdcModalOpenIndex]?.focus();
    }, 0);
  };

  return (
    <>
      {/* {modifyVoucherPage ? (
        <ModifyVoucher modifyVoucherNo={modifyVoucherNo} />
      ) : ( */}
      <div className="p-2 ">
        <div className="flex items-center justify-between  ">
          <h2 className="text-xl text-gray-800">Voucher</h2>
          <button
            onClick={onVoucherView}
            className="relative ml-4 bg-blue-600 text-white font-medium text-[17px] px-2 py-[0.35em]  h-[1.8em] rounded-[1.8em] flex items-center overflow-hidden cursor-pointer   group"
          >
            <span className="mr-8">View</span>
            <div className="absolute right-[0.3em] bg-white h-[1.2em] w-[1.6em] rounded-[0.8em] rounded-[0.2em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)]  active:scale-95">
              <FaEye className=" text-blue-600 " />
            </div>
          </button>
        </div>

        <div className="shadow-sm border border-gray-200 rounded-md p-4 bg-white max-w-7xl mx-auto">
          <div className="flex justify-between ">
            <div></div>

            <div className="flex">
              {modifyButton ? (
                <div className="flex justify-center items-center gap-2 h-full">
                  <div className="bg-gradient-to-b from-stone-300/40 to-transparent p-[2px] rounded-[16px] ">
                    <button
                      // disabled={disableModify}
                      onClick={onNew}
                      className={`group p-[2px] rounded-[8px] shadow-[0_1px_1px_rgba(0,0,0,0.5)] active:shadow-[0_0px_1px_rgba(0,0,0,0.5)] active:scale-[0.995]`}
                    >
                      <div className="bg-gradient-to-b from-stone-200/40 to-white/80 rounded-[8px] px-2 py-1">
                        <div className="flex gap-2 items-center">
                          <Plus className="w-3 h-4" />
                          <span className="font-semibold text-sm">New</span>
                        </div>
                      </div>
                    </button>
                  </div>
                  <div className="bg-gradient-to-b from-stone-300/40 to-transparent p-[2px] rounded-[16px] ">
                    <button
                      // disabled={disableModify}
                      // onClick={onDelete}
                      onClick={() => setShowDeleteConfirm(true)}
                      className={`group p-[2px] rounded-[8px] shadow-[0_1px_1px_rgba(0,0,0,0.5)] active:shadow-[0_0px_1px_rgba(0,0,0,0.5)] active:scale-[0.995]`}
                    >
                      <div className="bg-gradient-to-b from-stone-200/40 to-white/80 rounded-[8px] px-2 py-1">
                        <div className="flex gap-2 items-center">
                          <Trash2 className="w-3 h-4" />
                          <span className="font-semibold text-sm">Delete</span>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              ) : (
                <div className="flex justify-center items-center gap-12 h-full">
                  <div className="bg-gradient-to-b from-stone-300/40 to-transparent p-[2px] rounded-[16px] ">
                    <button
                      disabled={disableModify}
                      onClick={onModify}
                      className={`group p-[2px] rounded-[8px] shadow-[0_1px_1px_rgba(0,0,0,0.5)] active:shadow-[0_0px_1px_rgba(0,0,0,0.5)] active:scale-[0.995] 
    ${
      disableModify
        ? "bg-gray-200 cursor-not-allowed opacity-60"
        : "bg-gradient-to-b from-white to-stone-200/40 hover:bg-gray-400"
    }`}
                    >
                      <div className="bg-gradient-to-b from-stone-200/40 to-white/80 rounded-[8px] px-2 py-1">
                        <div className="flex gap-2 items-center">
                          <Edit3 className="w-3 h-4" />
                          <span className="font-semibold text-sm">Modify</span>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-6 ">
            <div className="flex justify-left gap-2 items-start  ">
              <div className="w-[70%]">
                <label className="block text-sm font-medium mb-1">
                  Voucher Type
                </label>
                <select
                  value={selectedVoucherType}
                  ref={voucherTypeRefs}
                  // onChange={(e) => setSelectedVoucherType(e.target.value)}
                  onChange={handleVoucherTypeChange}
                  className="w-full px-3 py-2 text-sm border-none bg-gray-100 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select Voucher Type</option>
                  {voucherTypeList?.map((voucher) => (
                    <option key={voucher.VTYPE} value={voucher.VTYPE}>
                      {voucher.VDESCRIPTION} - {voucher.VTYPE}
                    </option>
                  ))}
                </select>
              </div>
              {/* <div className="w-[30%]">
                <label className="block text-sm font-medium mb-1">
                  Voucher No
                </label>
                <input
                  type="text"
                  value={pvnoFromAPI}
                  readOnly
                  className="w-full px-3 py-2 text-sm border-none rounded bg-gray-100"
                />
              </div> */}

              <div className="w-[30%]">
                <label className="block text-sm font-medium mb-1">
                  Voucher No
                </label>
                <div className="flex items-center gap-2">
                  {/* Previous Button */}
                  <button
                    type="button"
                    onClick={() => handleVoucherChange("prev")}
                    className="p-2 bg-gray-200 hover:bg-gray-300 rounded-md transition"
                  >
                    <ChevronLeft className="w-4 h-4 text-gray-700" />
                  </button>

                  {/* Voucher Display */}
                  <input
                    type="text"
                    value={pvnoFromAPI}
                    readOnly
                    className="w-full px-3 py-2 text-sm border-none rounded bg-gray-100 text-center"
                  />

                  {/* Next Button */}
                  {/* <button
                    type="button"
                    onClick={() => handleVoucherChange("next")}
                    className="p-2 bg-gray-200 hover:bg-gray-300 rounded-md transition"
                  >
                    <ChevronRight className="w-4 h-4 text-gray-700" />
                  </button> */}

                  <button
                    type="button"
                    onClick={() => handleVoucherChange("next")}
                    disabled={Number(pvnoFromAPI) >= Number(pvnoFromAPI + 1)}
                    className={`p-2 rounded-md transition ${
                      !Number(pvnoFromAPI + 1) ||
                      Number(pvnoFromAPI + 1) > Number(pvnoFromAPI)
                        ? // ? "bg-gray-100 cursor-not-allowed"
                          "bg-gray-50 "
                        : "bg-gray-200 hover:bg-gray-300"
                    }`}
                  >
                    <ChevronRight className="w-4 h-4 text-gray-700" />
                  </button>
                </div>
              </div>
            </div>

            {/* <div>
          <label className="block text-sm font-medium mb-1">
            From Template
          </label>
          <input
            type="text"
            className="w-full px-3 py-2 text-sm border-none bg-gray-100 rounded-md"
          />
        </div> */}

            {/* <div>
          <label className="block text-sm font-medium mb-1">Voucher No</label>
          <input
            type="text"
            value={pvnoFromAPI}
            readOnly
            className="w-full px-3 py-2 text-sm border-none rounded bg-gray-100"
          />
        </div> */}

            <div>
              <div className="flex justify-between items-center">
                <label className="block text-sm font-medium mb-1">
                  Comments <span className="text-red-600">*</span>
                </label>
              </div>
              <textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Enter comments"
                className="p-2 rounded-lg bg-gray-100 border-none focus:ring-blue-500 focus:border-blue-500 w-full h-[85px]"
                rows={4}
              />
            </div>
            <div>
              <div className="flex justify-left items-start ">
                <div className="w-[70%]">
                  <label className="block text-sm font-medium mb-1">
                    Voucher Date
                  </label>
                  <input
                    type="date"
                    value={jvDate}
                    onChange={(e) => setJvDate(e.target.value)}
                    className="w-full px-3 py-2 text-sm border-none rounded bg-gray-100"
                  />
                </div>

                {/* this down  (recurring toggle ) will be for modifying with mode=='R' */}
                {modifyButton ? (
                  <>
                    {isRecurringInModifyData ? (
                      <div className="w-[30%] flex justify-between items-center">
                        <label
                          className={`text-xs font-medium mt-6 ml-4 mr-2 text-gray-400 cursor-not-allowed`}
                        >
                          Recurring Journal true "R"
                        </label>

                        <div className="flex items-center gap-2 mt-6">
                          <label
                            className={`relative inline-block w-[3.5em] h-[2em] `}
                          >
                            <input
                              type="checkbox"
                              className="peer sr-only"
                              checked={true}
                              onChange={onRecurringJournal}
                              disabled={true}
                            />
                            <span
                              className={`
                  absolute cursor-pointer inset-0  rounded-full transition-all duration-300 ease-in-out
                  after:content-[''] after:absolute after:top-[4px] after:left-[4px] 
                  after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
                  after:transition-all after:duration-300 after:ease-in-out
                  after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
                  peer-checked:bg-blue-500
                  peer-checked:bg-opacity-50
                  peer-checked:after:translate-x-[1.5em]
                  peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
                  peer-active:after:w-[3em]
                  peer-checked:peer-active:after:translate-x-[0.5em]
                  bg-gray-300 cursor-not-allowed`}
                            ></span>
                          </label>
                        </div>
                      </div>
                    ) : (
                      // {/* this down (no recurring toggle) will be for modifying with mode==''  */}

                      <div className="w-[30%] flex justify-between items-center">
                        <label
                          className={`text-xs font-medium mt-6 ml-4 mr-2 text-gray-400 cursor-not-allowed `}
                        >
                          Recurring Journal
                        </label>

                        <div className="flex items-center gap-2 mt-6">
                          <label
                            className={`relative inline-block w-[3.5em] h-[2em] `}
                          >
                            <input
                              type="checkbox"
                              className="peer sr-only"
                              checked={false}
                              onChange={onRecurringJournal}
                              disabled={true}
                            />
                            <span
                              className={`
                  absolute cursor-pointer inset-0  rounded-full transition-all duration-300 ease-in-out
                  after:content-[''] after:absolute after:top-[4px] after:left-[4px] 
                  after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
                  after:transition-all after:duration-300 after:ease-in-out
                  after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
                  peer-checked:bg-blue-500
                  peer-checked:after:translate-x-[1.5em]
                  peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
                  peer-active:after:w-[3em]
                  peer-checked:peer-active:after:translate-x-[0.5em]
                  bg-gray-300 cursor-not-allowed`}
                            ></span>
                          </label>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {/* this down  recurring toggle will be for saving  */}

                    {/* <Tooltip
                      title={
                        isAnyAccountEmpty
                          ? "Account must not be empty"
                          : isDebitZero
                          ? "Debit must not be zero"
                          : isCreditZero
                          ? "Credit must not be zero"
                          : !isDifferenceZero
                          ? "Credit and Debit must be equal"
                          : ""
                      }
                      arrow
                    > */}
                    <Tooltip
                      title={!isDifferenceZero ? "Difference must be 0" : ""}
                      arrow
                    >
                      <div className="w-[30%] flex justify-between items-center">
                        <label
                          className={`text-xs font-medium mt-6 ml-4 mr-2  ${
                            isRecurringDisabled || disableGenerate
                              ? "text-gray-400 cursor-not-allowed"
                              : ""
                          }`}
                        >
                          Recurring Journal for saving
                        </label>

                        <div className="flex items-center gap-2 mt-6">
                          <label
                            className={`relative inline-block w-[3.5em] h-[2em] `}
                          >
                            <input
                              type="checkbox"
                              className="peer sr-only"
                              checked={recurringJournal}
                              onChange={onRecurringJournal}
                              disabled={isRecurringDisabled || disableGenerate}
                            />
                            <span
                              className={`
                  absolute cursor-pointer inset-0  rounded-full transition-all duration-300 ease-in-out
                  after:content-[''] after:absolute after:top-[4px] after:left-[4px] 
                  after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
                  after:transition-all after:duration-300 after:ease-in-out
                  after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
                  peer-checked:bg-blue-500
                  peer-checked:after:translate-x-[1.5em]
                  peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
                  peer-active:after:w-[3em]
                  peer-checked:peer-active:after:translate-x-[0.5em]
                    ${
                      isRecurringDisabled || disableGenerate
                        ? "bg-gray-300 cursor-not-allowed peer-checked:bg-opacity-50"
                        : "bg-gray-400"
                    }`}
                            ></span>
                          </label>
                        </div>
                      </div>
                    </Tooltip>
                  </>
                )}
              </div>

              {recurringJournal ? (
                <div className="flex justify-between mt-12 gap-4 items-center ">
                  <div className="">
                    <label
                      className={`block text-sm font-medium mb-1. ${
                        disableGenerate
                          ? "text-gray-400 cursor-not-allowed opacity-60"
                          : ""
                      } `}
                    >
                      Start Date
                    </label>
                    <input
                      disabled={disableGenerate}
                      type="date"
                      value={jvRecurringDate}
                      onChange={(e) => setJvRecurringDate(e.target.value)}
                      className={`w-full px-3 py-2 text-sm border-none rounded bg-gray-100  ${
                        disableGenerate
                          ? "bg-gray-200 cursor-not-allowed opacity-60"
                          : ""
                      }`}
                    />
                  </div>

                  <div>
                    <label
                      className={`block text-sm font-medium mb-1 ${
                        disableGenerate
                          ? "text-gray-400 cursor-not-allowed opacity-60"
                          : ""
                      } `}
                    >
                      Frequency
                    </label>
                    <input
                      value={frequency}
                      onChange={(e) => setFrequency(e.target.value)}
                      // type="text"
                      disabled={disableGenerate}
                      className={`w-full px-3 py-2 text-sm border-none rounded bg-gray-100   ${
                        disableGenerate
                          ? "bg-gray-200 cursor-not-allowed opacity-60"
                          : ""
                      } `}
                    />
                  </div>

                  <div className="flex flex-col gap-4 font-poppins mt-5">
                    <div
                      className={`flex items-center gap-2.5 rounded-lg border border-gray-200 p-2 
                     ${
                       disableGenerate
                         ? "bg-gray-200 cursor-not-allowed opacity-60"
                         : ""
                     }
                    `}
                    >
                      {["daily", "monthly", "yearly"].map((plan) => (
                        <div
                          key={plan}
                          className={`flex-1  ${
                            disableGenerate
                              ? "bg-gray-200 cursor-not-allowed opacity-60"
                              : ""
                          } `}
                        >
                          <input
                            disabled={disableGenerate}
                            type="radio"
                            name="plan"
                            id={plan}
                            value={plan}
                            className="hidden peer"
                            checked={selectedPlan === plan}
                            onChange={() => setSelectedPlan(plan)}
                          />
                          <label
                            htmlFor={plan}
                            className={`block text-center p-2 rounded-lg text-xs font-semibold cursor-pointer transition-all duration-500 ease-in-out
                                ${
                                  disableGenerate
                                    ? "bg-gray-200 cursor-not-allowed opacity-60"
                                    : ""
                                } 
            ${
              selectedPlan === plan
                ? "bg-[#3A80F2] text-white shadow-[0_0_2px_0_#3A80F2]"
                : "bg-white text-[#000000]"
            }`}
                          >
                            {plan.charAt(0).toUpperCase() + plan.slice(1)}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div
                    className={`mt-4 bg-gradient-to-b from-stone-300/40 to-transparent p-[2px] rounded-[16px] flex items-center`}
                  >
                    {/* <Tooltip
                      title={disableGenerate ? "Enter Frequency" : ""}
                      arrow
                    > */}
                    {/* <Tooltip
                      title={disableGenerate || Number(frequency)<0 ? "Enter Frequency" : ""}
                      arrow
                    > */}
                    <Tooltip
                      title={
                        !frequency || Number(frequency) <= 0
                          ? "Enter Frequency"
                          : ""
                      }
                      arrow
                    >
                      <button
                        disabled={disableGenerate}
                        onClick={onGenerate}
                        className={`group  rounded-[8px] shadow-[0_1px_1px_rgba(0,0,0,0.5)] active:shadow-[0_0px_1px_rgba(0,0,0,0.5)] active:scale-[0.995] 
    ${
      disableGenerate
        ? "bg-gray-200 cursor-not-allowed opacity-60"
        : "bg-gradient-to-b from-white to-stone-200/40 hover:bg-gray-400"
    }`}
                      >
                        <div className="bg-gradient-to-b from-stone-200/40 to-white/80 rounded-[8px] px-2 py-1">
                          <div className="flex gap-2 items-center">
                            <Sparkles className="w-4 h-4" />
                            <span className="font-semibold text-sm">
                              Generate
                            </span>
                          </div>
                        </div>
                      </button>
                    </Tooltip>
                  </div>
                </div>
              ) : (
                <div></div>
              )}
              {/* <div>
                <label className="block text-sm font-medium mb-1">
                  Company List
                </label>
                <select
                  value={COMPANY_CODE}
                  onChange={(e) => setCOMPANY_CODE(e.target.value)}
                  className="w-full px-3 py-2 text-sm border-none bg-gray-100 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  {localStorage.getItem("companyCode") !== "SUNRISEJP" &&
                    localStorage.getItem("companyCode") !== "SUNRISE" && (
                      <option value={localStorage.getItem("companyCode")}>{COMPANY_NAME}</option>
                    )}
                  <option value={"SUNRISEJP"}>
                    {"J P TRADING LLC"}
                  </option>
                  <option value={"SUNRISE"}>
                    {"SUNRISE OASIS LLC"}
                  </option>
                </select>
              </div> */}
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">
                Voucher Timeline
              </label>
              <div
                className="bg-[#F3F4F6]  rounded border"
                style={{
                  height: "160px",
                  overflowY: "scroll",
                  padding: "6px",
                  // marginRight: "10px",
                }}
              >
                {voucherTimeLineList ? (
                  voucherTimeLineList.length > 0 ? (
                    voucherTimeLineList?.map((item) => {
                      return (
                        <div className=" bg-white border rounded shadow p-1 m-2">
                          <p className="flex">
                            <div>
                              <img src={ic_timeline_circle_indicator} />
                            </div>
                            <div className="ms-2  w-full">
                              <div className="flex justify-between items-center">
                                {/* <div> */}
                                <span className="text-xs font-semibold">
                                  {format(item.create_date, "dd-MM-yyyy")}{" "}
                                </span>
                                <span
                                  className="text-xs font-semibold"
                                  style={{ marginLeft: "5px" }}
                                >
                                  {format(item.create_date, "hh:mm a")}{" "}
                                </span>
                                <span
                                  className="text-xs font-semibold"
                                  style={{ marginLeft: "5px" }}
                                >
                                  User: {item.userid}
                                </span>
                                {/* </div> */}
                                <div className="px-1">
                                  <span className="bg-gray-100 text-gray-400 text-xs font-medium me-2 px-1.5 py-0.5 rounded dark:bg-gray-700 dark:text-white">
                                    {" "}
                                    {item.status}{" "}
                                  </span>
                                </div>
                              </div>
                              {/* <div> */}
                              {/* <span>{item.Comments}</span> */}
                              {/* </div> */}
                            </div>
                          </p>
                        </div>
                      );
                    })
                  ) : (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img style={{ width: "90px" }} src={ic_no_data} />
                      <p className="p-2 text-slate-500">
                        {" "}
                        No data in voucher timeline
                      </p>
                    </div>
                  )
                ) : (
                  <p>
                    Unable to fetch voucher timeline, please contact support
                    team.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>

        {pvnoFromAPI ? (
          <>
            {/* {modifyVoucherPage ? (
               <ModifyVoucher modifyVoucherNo={modifyVoucherNo} />
             ) : ( */}
            <div className="max-w-7xl mx-auto mb-4">
              <div className="mt-4 border rounded bg-white overflow-x-auto overflow-y-auto h-[28vh] mx-auto">
                <table className="min-w-full border-collapse text-sm max-h-600">
                  <thead className="bg-gray-100 sticky top-0 z-20">
                    <tr className="min-h-12">
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[40px]">
                        <input
                          type="checkbox"
                          className={`w-6 h-6 rounded-md border-gray-400 shadow-sm transition-all duration-300 ease-in-out
        focus:ring-blue-500 focus:border-blue-500 opacity-100 cursor-pointer transition-opacity duration-300`}
                          checked={
                            entries.length > 0 &&
                            entries.every((e) => e?.selected)
                          }
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setEntries((prev) =>
                              prev.map((entry) => ({
                                ...entry,
                                selected: checked,
                              })),
                            );
                          }}
                        />
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[60px]">
                        SL No.
                      </th>
                      {(recurringJournal || isRecurringInModifyData) && (
                        <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
                          Recurring Date
                        </th>
                      )}
                      {/* <th className="border px-2 py-1 font-normal text-sm text-center min-w-[150px]">
                        Company
                      </th> */}
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[150px]">
                        Account
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[300px]">
                        Account Name
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[120px]">
                        Reference
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[180px]">
                        Description
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[60px]">
                        TY
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[120px]">
                        Amount
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[240px]">
                        Cur
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[140px]">
                        Rate
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[120px]">
                        FC Amount
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
                        Chq No
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
                        Chq Date
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[150px]">
                        Bank
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[150px]">
                        PDC acc
                      </th>
                      {/* <th className="border px-2 py-1 font-normal text-sm text-center min-w-[50px]">
                  X
                </th> */}
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[120px]">
                        Job Code
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[120px]">
                        C Center
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[120px]">
                        Cost Code
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
                        VatAmt
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[150px]">
                        Total
                      </th>
                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
                        TRN
                      </th>

                      <th className="border px-2 py-1 font-normal text-sm text-center min-w-[100px]">
                        VAT %
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {entries?.map((row, index) => (
                      <tr
                        key={index}
                        className="max-h-12"
                        ref={accountRowContainerRef}
                        onClick={() => setSetupBillAccount(row.account)}
                      >
                        <td className="border px-2 py-1 text-center">
                          <input
                            type="checkbox"
                            checked={row?.selected || false}
                            className={` w-6 h-6 rounded-md border-gray-400 shadow-sm transition-all duration-300 ease-in-out
        focus:ring-blue-500 focus:border-blue-500 opacity-100 cursor-pointer transition-opacity duration-300`}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setEntries((prev) => {
                                const updated = [...prev];
                                updated[index].selected = checked;
                                return updated;
                              });
                            }}
                          />
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal text-center">
                          {index + 1}
                        </td>
                        {/* <td className="border px-2 py-1 text-sm font-normal text-center">
                          {row.companyCode}
                        </td> */}

                        {(recurringJournal || isRecurringInModifyData) && (
                          <td className="border px-2 py-1 text-sm font-normal text-right">
                            <input
                              ref={(el) =>
                                (reccurringDateRefs.current[index] = el)
                              }
                              type="date"
                              // value={row.docDate}
                              // value={dayjs(
                              //     row.docDate
                              //   ).format("YYYY-MM-DD")}
                              value={
                                recurringJournal
                                  ? generatedEntriesState?.length > 0
                                    ? dayjs(row.docDate).format("YYYY-MM-DD")
                                    : dayjs(jvRecurringDate).format(
                                        "YYYY-MM-DD",
                                      )
                                  : isRecurringInModifyData
                                    ? dayjs(row.docDate).format("YYYY-MM-DD")
                                    : ""
                              }
                              onChange={(e) => {
                                const formatted = dayjs(e.target.value).format(
                                  "YYYY-MM-DD",
                                );
                                handleChange(index, "docDate", formatted);
                              }}
                              onFocus={(e) => e.target.showPicker?.()} // auto-open date picker
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  accountRefs.current[index]?.focus();
                                }
                              }}
                              className="w-full text-right px-2 py-1 text-sm border-none rounded cursor-pointer focus:outline-none focus:ring-1 focus:ring-blue-400"
                            />
                          </td>
                        )}

                        <td className="border text-sm font-normal relative">
                          <div ref={accountContainerRef} className="relative">
                            <input
                              ref={(el) => (accountRefs.current[index] = el)}
                              // value={row?.account.trim()}
                              value={row?.account || ""}
                              onFocus={(e) => {
                                e.target.select();
                                setDropdownOpenIndex(index);
                                setSearchVoucherAccountTerm(row.account);
                                // setSetupBillAccount(row.account);
                              }}
                              onChange={(e) => {
                                handleChange(index, "account", e.target.value);
                                setDropdownOpenIndex(index);

                                setSelectedAccountsState((prev) => {
                                  const updated = [...prev];
                                  updated[index] = false;
                                  return updated;
                                });
                              }}
                              // onBlur={(e) => {
                              //   handleChange(
                              //     index,
                              //     "account",
                              //     e.target.value.trim()
                              //   );
                              // }}
                              onKeyDown={(e) => {
                                if (e.key === "F2") {
                                  // fetchAccountList("ALL");
                                  setSelectedRowIndex(index);
                                  setVoucherModalOpen(true);
                                  setDropdownOpenIndex(null);
                                }

                                // ⬇ open dropdown and highlight first item
                                if (e.key === "ArrowDown") {
                                  e.preventDefault();
                                  setDropdownOpenIndex(index);
                                  setHighlightedIndex(0);
                                }

                                // Enter key (if dropdown not open)
                                if (
                                  e.key === "Enter" &&
                                  dropdownOpenIndex !== index
                                ) {
                                  e.preventDefault();
                                  accountNameRefs.current[index]?.focus();
                                }

                                // Navigate dropdown
                                if (
                                  dropdownOpenIndex === index &&
                                  filteredAccounts?.length > 0
                                ) {
                                  if (e.key === "ArrowUp") {
                                    e.preventDefault();
                                    setHighlightedIndex((prev) =>
                                      prev > 0
                                        ? prev - 1
                                        : filteredAccounts.length - 1,
                                    );
                                  } else if (e.key === "ArrowDown") {
                                    e.preventDefault();
                                    setHighlightedIndex((prev) =>
                                      prev < filteredAccounts.length - 1
                                        ? prev + 1
                                        : 0,
                                    );
                                  } else if (e.key === "Enter") {
                                    e.preventDefault();
                                    const selectedAcc =
                                      filteredAccounts[highlightedIndex];
                                    if (selectedAcc)
                                      // handleSelectAccount(index, selectedAcc);
                                      handleDropdownSelectAccount(
                                        index,
                                        selectedAcc,
                                      );
                                  } else if (e.key === "Escape") {
                                    setDropdownOpenIndex(null);
                                    setHighlightedIndex(-1);
                                  }
                                }
                              }}
                              className={`w-full px-2 py-1 m-0 text-sm border-none rounded focus:ring-1 focus:ring-blue-400
  ${
    row?.account && !selectedAccountsState[index]
      ? "bg-red-400"
      : "bg-transparent"
  }`}
                            />
                            {/* commented because its listing all and not correct for suggestions */}
                            {/* {dropdownOpenIndex === index && (
                              <div
                                ref={(el) =>
                                  (voucherDropdownRefs.current[index] = el)
                                }
                                className="absolute z-10 left-0 top-7 bg-white border border-gray-300 w-[300px] mt-1 max-h-40 shadow-lg overflow-y-auto rounded-md "
                              >
                                {filteredAccounts?.length > 0 ? (
                                  filteredAccounts.map((acc, i) => (
                                    <div
                                      key={i}
                                      onClick={() => {
                                        handleDropdownSelectAccount(index, acc);
                                      }}
                                      className={`px-1 py-2 text-sm flex items-center gap-4 cursor-pointer border-b border-gray-100 last:border-b-0 ${i === highlightedIndex
                                        ? "bg-blue-100 hover:bg-blue-200"
                                        : "hover:bg-gray-100"
                                        }`}
                                    >
                                      <div className="text-xs font-semibold text-white bg-blue-500 px-2 py-1 rounded-md">
                                        {acc.ACCOUNT}
                                      </div>
                                      <div className="font-thin text-gray-900 text-xs truncate max-w-[250px]">
                                        {acc.DESCRIPTION}
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div className="w-[310px] p-3 flex flex-row items-center justify-start bg-[#F7C752] rounded-lg shadow-[0_0_5px_-3px_#111] font-sans">
                                    <div className="w-5 h-5 -translate-y-0.5 mr-2">
                                      <svg
                                        fill="none"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        width="24"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="m13 14h-2v-5h2zm0 4h-2v-2h2zm-12 3h22l-11-19z"
                                          fill="#393A37"
                                        ></path>
                                      </svg>
                                    </div>
                                    <div className="text-sm font-semi-bold text-[#393A37] italic">
                                      Account not available in list
                                    </div>
                                  </div>
                                )}
                              </div>
                            )} */}
                          </div>
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal">
                          <input
                            ref={(el) => (accountNameRefs.current[index] = el)}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            value={row?.accdesc || row?.description}
                            onChange={(e) =>
                              handleChange(index, "accdesc", e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // prevent form submission or newline
                                invRefs.current[index]?.focus(); // move focus to INV input
                              }
                            }}
                            className="w-full px-2 py-1 text-sm border-none rounded"
                          />
                        </td>
                        {/* <td className="border px-2 py-1 text-sm font-normal text-right">
                            <input
                              onFocus={(e) => {
                                e.target.select();
                              }}
                              ref={(el) => (invRefs.current[index] = el)}
                              value={row.ref || row.INV || ''}
                              onChange={(e) =>
                                handleChange(index, "INV", e.target.value)
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  descriptionRefs.current[index]?.focus();
                                }
                              }}
                              className="w-full text-right px-2 py-1 text-sm border-none rounded"
                            />
                          </td> */}

                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            onFocus={(e) => e.target.select()}
                            ref={(el) => (invRefs.current[index] = el)}
                            value={row?.INV || row?.ref || ""} // Check both fields
                            onChange={(e) =>
                              handleChange(index, "INV", e.target.value)
                            } // Always update INV
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                descriptionRefs.current[index]?.focus();
                              }
                            }}
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                          />
                        </td>

                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            ref={(el) => (descriptionRefs.current[index] = el)}
                            value={row?.LPONO || row?.DESCR}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            onChange={(e) =>
                              handleChange(index, "DESCR", e.target.value)
                            }
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // prevent form submission or newline
                                tyRefs.current[index]?.focus(); // move focus to INV input
                              }
                            }}
                          />
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <button
                            ref={(el) => (tyRefs.current[index] = el)}
                            onClick={() => handleTyData(index)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                // Move focus to next row's first cell (Description input for example)
                                amountRefs.current[index]?.focus();
                              } else if (e.key === " ") {
                                e.preventDefault(); // prevent page scroll when pressing space
                                handleTyData(index); // toggle value on spacebar
                              }
                            }}
                            className={`w-full text-center px-2 py-1 text-sm rounded ${
                              row?.ty === "D" ? "bg-green-400" : "bg-red-400"
                            }`}
                          >
                            {row?.ty}
                          </button>
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            ref={(el) => (amountRefs.current[index] = el)}
                            value={row?.amount ?? row?.AMOUNT ?? ""}
                            onChange={(e) => {
                              const handler = !modifyButton
                                ? handleChangeAmountEntry
                                : handleChangeAmountModify;
                              handler(index, "AMOUNT", e.target.value);
                            }}
                            onFocus={(e) => e.target.select()}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                curRefs.current[index]?.focus();
                              }
                            }}
                            type="number"
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                          />
                        </td>

                        <td className="border  text-sm font-normal text-right">
                          {/* <input
                      ref={(el) => (curRefs.current[index] = el)}
                      value={row.CUR}
                      onFocus={(e) => {
                        e.target.select();
                      }}
                      onChange={(e) =>
                        handleChange(index, "CUR", e.target.value)
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // prevent form submission or newline
                          rateRefs.current[index]?.focus(); // move focus to INV input
                        }
                      }}
                      className="w-full text-right px-2 py-1 text-sm border-none rounded"
                    /> */}

                          <select
                            ref={(el) => (curRefs.current[index] = el)}
                            value={row?.curno || ""} // use row-specific value
                            onChange={(e) => {
                              handleCurrencyChange(index, e.target.value);
                              const handler = !modifyButton
                                ? handleChangeAmountEntry
                                : handleChangeAmountModify;
                              handler(index, "AMOUNT", e.target.value);
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                rateRefs.current[index]?.focus();
                              }
                            }}
                            className="w-full px-3 py-2 text-sm bg-transparent border-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                          >
                            {currencies.map((currency) => (
                              <option
                                key={currency.curno}
                                value={currency.curno}
                              >
                                {currency.curno} - {currency.cur.trim()}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            ref={(el) => (rateRefs.current[index] = el)}
                            // value={selectedCurrency?.rate?.toFixed(6)}
                            value={row?.rate || "1"}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            onChange={
                              (e) =>
                                // handleChange(index, "rate", e.target.value)
                                handleChangeRate(index, e.target.value)
                              // setSelectedCurrencyRate(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // prevent form submission or newline
                                fcBalRefs.current[index]?.focus(); // move focus to INV input
                              }
                            }}
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                          />
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            ref={(el) => (fcBalRefs.current[index] = el)}
                            value={row?.curamount || row?.FCBalAmt}
                            // value={(row.AMOUNT * selectedCurrencyRate).toFixed(2)}
                            // value={row.AMOUNT}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            onChange={(e) =>
                              handleChangeFCBalAmt(index, e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // prevent form submission or newline
                                chqNoRefs.current[index]?.focus(); // move focus to INV input
                              }
                            }}
                            type="number"
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                          />
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            value={row?.chqNo}
                            ref={(el) => (chqNoRefs.current[index] = el)}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            onChange={(e) =>
                              handleChange(index, "chqNo", e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // prevent form submission or newline
                                chqDateRefs.current[index]?.focus(); // move focus to INV input
                              }
                            }}
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                          />
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            ref={(el) => (chqDateRefs.current[index] = el)}
                            type="date"
                            value={
                              row?.chqdate || row?.chqDate
                                ? dayjs(row?.chqDate, "YYYY-MM-DD").format(
                                    "YYYY-MM-DD",
                                  ) // HTML expects this format
                                : ""
                            }
                            onChange={(e) => {
                              const formatted = dayjs(e.target.value).format(
                                "YYYY-MM-DD",
                              ); // ✅ store in backend format
                              handleChange(index, "chqDate", formatted);
                            }}
                            onFocus={(e) => e.target.showPicker?.()} // auto-open date picker
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                bankRefs.current[index]?.focus();
                              }
                            }}
                            className="w-full text-right px-2 py-1 text-sm border-none rounded cursor-pointer focus:outline-none focus:ring-1 focus:ring-blue-400"
                          />
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            ref={(el) => (bankRefs.current[index] = el)}
                            value={row?.bank || row?.Bank}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            onChange={(e) =>
                              handleChange(index, "Bank", e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // prevent form submission or newline
                                pdcAccRefs.current[index]?.focus(); // move focus to INV input
                              }
                            }}
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                          />
                        </td>
                        {/* <td className="border px-2 py-1 text-sm font-normal text-right">
                    <input
                      ref={(el) => (pdcAccRefs.current[index] = el)}
                      value={row.pdcAcc}
                      onFocus={(e) => {
                        e.target.select();
                      }}
                      onChange={(e) =>
                        handleChange(index, "pdcAcc", e.target.value)
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // prevent form submission or newline
                          jobCodeRefs.current[index]?.focus(); // move focus to INV input
                        }
                      }}
                      className="w-full text-right px-2 py-1 text-sm border-none rounded"
                    />
                  </td> */}
                        <td className="border px-2 py-1 text-sm font-normal relative">
                          <div className="relative">
                            <input
                              ref={(el) => (pdcAccRefs.current[index] = el)}
                              value={row?.pdc_acc || row?.pdcAcc}
                              onFocus={(e) => {
                                e.target.select();
                                setPdcModalOpenIndex(index);
                              }}
                              onChange={(e) => {
                                handleChangePdcAcc(
                                  index,
                                  "pdcAcc",
                                  e.target.value,
                                );
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "F2") {
                                  e.preventDefault();
                                  setPdcModalOpenIndex(index);
                                  setPdcDropdownOpenIndex(null);
                                  setPdcModalOpen(true);
                                }

                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  jobCodeRefs.current[index]?.focus();
                                }
                              }}
                              className="w-full px-2 py-1 text-sm border-none rounded focus:ring-1 focus:ring-blue-400"
                            />
                          </div>
                        </td>
                        {/* <td className="border px-2 py-1 text-sm font-normal text-right">
                    <input
                      ref={(el) => (xRefs.current[index] = el)}
                      value={row.x}
                      onFocus={(e) => {
                        e.target.select();
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // prevent form submission or newline
                          jobCodeRefs.current[index]?.focus(); // move focus to INV input
                        }
                      }}
                      onChange={(e) => handleChange(index, "x", e.target.value)}
                      className="w-full text-right px-2 py-1 text-sm border-none rounded"
                    />
                  </td> */}
                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            ref={(el) => (jobCodeRefs.current[index] = el)}
                            value={row?.job_code || row?.JOBCODE}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            onChange={(e) =>
                              handleChange(index, "JOBCODE", e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // prevent form submission or newline
                                costCodeRefs.current[index]?.focus(); // move focus to INV input
                              }
                            }}
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                          />
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            ref={(el) => (costCodeRefs.current[index] = el)}
                            value={row?.COSTCODE || row?.costCode}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            onChange={(e) =>
                              handleChange(index, "costCode", e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // prevent form submission or newline
                                cCenterRefs.current[index]?.focus(); // move focus to INV input
                              }
                            }}
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                          />
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            ref={(el) => (cCenterRefs.current[index] = el)}
                            value={row?.ccno || row?.CCENTER}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            onChange={(e) =>
                              handleChange(index, "CCENTER", e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // prevent form submission or newline
                                vatAmtRefs.current[index]?.focus(); // move focus to INV input
                              }
                            }}
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                          />
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            ref={(el) => (vatAmtRefs.current[index] = el)}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            value={
                              row?.v_amt || row?.vatOn
                                ? Number(
                                    (row?.amount ?? row?.AMOUNT) *
                                      (vatPercentage / 100),
                                  ).toFixed(2)
                                : ""
                            }
                            onChange={(e) => {
                              handleChange(index, "vatAmt", e.target.value);
                              // Auto-toggle VAT on when VAT amount is entered
                              if (
                                e.target.value &&
                                Number(e.target.value) > 0
                              ) {
                                const updatedEntries = [...entries];
                                updatedEntries[index].vatOn = true;
                                setEntries(updatedEntries);
                              }
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // prevent form submission or newline

                                totalRefs.current[index]?.focus(); // move focus to INV input
                              }
                            }}
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                          />
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            ref={(el) => (totalRefs.current[index] = el)}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            value={
                              row?.vatOn
                                ? (
                                    Number(row?.amount ?? row?.AMOUNT) +
                                    Number(row?.amount ?? row?.AMOUNT) *
                                      (vatPercentage / 100)
                                  ).toFixed(2)
                                : Number(row?.amount ?? row?.AMOUNT)
                            }
                            onChange={(e) =>
                              handleChange(index, "total", e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();

                                trnRefs.current[index]?.focus();
                              }
                            }}
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                          />
                        </td>
                        <td className="border px-2 py-1 text-sm font-normal text-right">
                          <input
                            ref={(el) => (trnRefs.current[index] = el)}
                            onFocus={(e) => {
                              e.target.select();
                            }}
                            value={row?.ttref || row?.trn}
                            onChange={(e) =>
                              handleChange(index, "trn", e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault(); // prevent form submission or newline
                                isVatRefs.current[index]?.focus();
                                // trnRefs.current[index+1]?.focus(); // move focus to INV input
                              }
                            }}
                            className="w-full text-right px-2 py-1 text-sm border-none rounded"
                          />
                        </td>

                        <td className="border px-2 py-1 text-sm text-right">
                          <div className="flex justify-between items-center">
                            <label className="text-md font-semibold mr-2">
                              {row?.vatOn ? vatPercentage : "0"}
                            </label>
                            <div className="flex items-center gap-2">
                              <label className="relative inline-block w-[3.5em] h-[2em]">
                                <input
                                  type="checkbox"
                                  ref={(el) => (isVatRefs.current[index] = el)}
                                  className="peer sr-only"
                                  checked={row?.vatOn || false}
                                  onChange={(e) =>
                                    handleVatToggle(index, e.target.checked)
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === " ") {
                                      e.preventDefault(); // prevent page scroll
                                      handleVatToggle(index, !row?.vatOn); // toggle ON/OFF
                                    } else if (e.key === "Enter") {
                                      e.preventDefault();
                                      // move focus to next row toggle if exists
                                      handleAddRow();
                                    }
                                  }}
                                />

                                <span
                                  className="
      absolute cursor-pointer inset-0 bg-gray-300 rounded-full transition-all duration-300 ease-in-out
      after:content-[''] after:absolute after:top-[4px] after:left-[4px] 
      after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
      after:transition-all after:duration-300 after:ease-in-out
      after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
      peer-checked:bg-blue-500
      peer-checked:after:translate-x-[1.5em]
      peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
      peer-active:after:w-[3em]
      peer-checked:peer-active:after:translate-x-[0.5em]
    "
                                ></span>
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="z-[10] flex border justify-between p-3 border-t sticky bottom-0 bg-gray-100 w-full text-sm font-medium">
                {/* <div className="flex items-center justify-between gap-16 text-sm font-medium"> */}
                <div className="flex justify-center items-center gap-2">
                  <button
                    type="button"
                    onClick={handleAddRow}
                    // className="px-3 py-1 text-sm border rounded bg-gray-50 hover:bg-gray-100"
                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition flex justify-center items-center gap-2"
                  >
                    <Plus className="w-3 h-4" />
                    <span className="font-semibold text-sm">Add Row</span>
                  </button>
                  {entries.some((entry) => entry?.selected) && (
                    <button
                      type="button"
                      className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition flex justify-center items-center gap-2"
                      onClick={() => {
                        setEntries((prev) =>
                          prev.filter((row) => !row?.selected),
                        );
                        setTY((prev) =>
                          prev.filter((_, i) => !entries[i]?.selected),
                        );
                      }}
                    >
                      <Trash2 className="w-3 h-4" />
                      <span className="font-semibold text-sm">Delete</span>
                    </button>
                  )}
                </div>
                <div className="flex gap-6 items-center justify-center">
                  <span className="font-normal">
                    Total Debit:{" "}
                    <span className="font-semibold">
                      {sumOfDebit.toFixed(2)}
                    </span>
                  </span>
                  <span className="font-normal">
                    Total Credit:{" "}
                    <span className="font-semibold">
                      {sumOfCredit.toFixed(2)}
                    </span>
                  </span>
                  {/* <span className="font-normal">
                        Diff:{" "}
                        <span className="font-semibold">
                          {(sumOfCredit - sumOfDebit)?.toFixed(2)}
                        </span>
                      </span> */}
                  <span className="font-medium">Difference:</span>{" "}
                  <span
                    className={`font-semibold ${
                      Number(difference) === 0
                        ? "text-green-600"
                        : "text-red-600"
                    }`}
                  >
                    {difference}
                  </span>
                </div>

                <div
                  ref={setupBillContainerRef}
                  className="flex gap-6 justify-center items-center"
                >
                  <Tooltip
                    title={!isAccountFocused ? "Please Select an Account" : ""}
                    arrow
                  >
                    <label
                      className={`text-md font-medium ${
                        !isAccountFocused
                          ? "opacity-50 cursor-not-allowed"
                          : "opacity-100 cursor-pointer"
                      } `}
                    >
                      Setup Bill
                      <input
                        disabled={!isAccountFocused}
                        className={`ml-2 w-6 h-6 rounded-md border-gray-400 shadow-sm transition-all duration-300 ease-in-out
        focus:ring-blue-500 focus:border-blue-500
        ${
          !isAccountFocused
            ? "opacity-50 cursor-not-allowed"
            : "opacity-100 cursor-pointer transition-opacity duration-300"
        }
      `}
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                      />
                    </label>
                  </Tooltip>
                  <label className="text-md font-medium">
                    Repeat Amount
                    <input
                      className="shadow-sm ml-2 border-gray-400 focus:ring-blue-500 focus:border-blue-500 rounded-md transition-all duration-500 ease-in-out w-6 h-6"
                      type="checkbox"
                      checked={isCheckedRepeatAmount}
                      onChange={(e) =>
                        setIsCheckedRepeatAmount(e.target.checked)
                      }
                    />
                  </label>
                  <label className="text-md font-medium">
                    Repeat Desc
                    <input
                      className="shadow-sm ml-2 border-gray-400 focus:ring-blue-500 focus:border-blue-500 rounded-md transition-all duration-500 ease-in-out w-6 h-6"
                      type="checkbox"
                      checked={isCheckedRepeatDesc}
                      onChange={(e) => setIsCheckedRepeatDesc(e.target.checked)}
                    />
                  </label>
                </div>
                {/* </div> */}
                {/* <div className="flex items-center justify-between w-30">
                  <label className="text-sm font-medium flex justify-center items-center gap-6">
                    <span>Doc Dt</span>
                  </label>
                  <input
                    type="date"
                    value={docDate}
                    onChange={(e) => setDocDate(e.target.value)}
                    className="bg-white ml-4 text-gray-700 border-gray-300 focus:ring-blue-500 focus:border-blue-500 px-2 py-1 rounded mt-1"
                  />
                </div> */}
                {/* <button
                  onClick={handleAddRow}
                  className="px-3 py-1 text-sm border rounded bg-gray-50 hover:bg-gray-100"
                >
                  Add Row
                </button> */}
              </div>
            </div>

            {modifyButton ? (
              <div className="justify-center items-center flex mt-4">
                <Tooltip
                  title={
                    isCommentEmpty
                      ? "Please enter a comment"
                      : isCreditZero
                        ? "Credit must not be zero"
                        : isDebitZero
                          ? "Debit must not be zero"
                          : !isDifferenceZero
                            ? "Credit and Debit must be equal"
                            : isAnyAccountEmpty
                              ? "Account must not be empty"
                              : isAnyAccountLength
                                ? "Account length must be equal to 8"
                                : isSelectedAccount
                                  ? "Select Account from list"
                                  : isAnyAmountZero
                                    ? "Amount must not be zero"
                                    : ""
                  }
                  arrow
                >
                  <span>
                    {" "}
                    {/* Required wrapper because disabled button blocks pointer events */}
                    {modifyVoucherDataFromView?.mode == "view" ? null : (
                      <button
                        onClick={onModifyVoucher}
                        disabled={isDisabled || saving}
                        className={`px-3 py-2 text-white text-sm border rounded w-[270px] transition flex items-center justify-center gap-2 ${
                          isDisabled || saving
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-gray-700 hover:bg-black"
                        }`}
                      >
                        {saving ? (
                          <>
                            <svg
                              className="animate-spin h-4 w-4 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              ></path>
                            </svg>
                            Saving...
                          </>
                        ) : (
                          "Modify"
                        )}
                      </button>
                    )}
                  </span>
                </Tooltip>
              </div>
            ) : (
              <div className="justify-center items-center flex mt-8">
                {/* <button
                  onClick={onSaveVoucher}
                  className="px-3 py-2 text-white text-sm border rounded bg-gray-700 hover:bg-black w-[270px]"
                >
                  Save
                </button>*/}
                {/* <Tooltip title={isDisabled ? getTooltipMessage() : ""} arrow> */}
                <Tooltip
                  title={
                    isCommentEmpty
                      ? "Please enter a comment"
                      : isCreditZero
                        ? "Credit must not be zero"
                        : isDebitZero
                          ? "Debit must not be zero"
                          : !isDifferenceZero
                            ? "Credit and Debit must be equal"
                            : isAnyAccountEmpty
                              ? "Account must not be empty"
                              : isAnyAccountLength
                                ? "Account length must be equal to 8"
                                : isSelectedAccount
                                  ? "Select Account from list"
                                  : isAnyAmountZero
                                    ? "Amount must not be zero"
                                    : ""
                  }
                  arrow
                >
                  <span>
                    {" "}
                    {/* Required wrapper because disabled button blocks pointer events */}
                    <button
                      onClick={onSaveVoucher}
                      disabled={isDisabled || saving}
                      className={`px-3 py-2 text-white text-sm border rounded w-[270px] transition flex items-center justify-center gap-2 ${
                        isDisabled || saving
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-gray-700 hover:bg-black"
                      }`}
                    >
                      {saving ? (
                        <>
                          <svg
                            className="animate-spin h-4 w-4 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          Saving...
                        </>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </span>
                </Tooltip>
              </div>
            )}
          </>
        ) : (
          ""
        )}
        {voucherModalOpen && (
          <Modal
            isOpen={voucherModalOpen}
            onClose={() => setVoucherModalOpen(false)}
            title={"Select Voucher Account"}
            size="xxl"
            header={true}
          >
            <CreditCustomerList
              companyCode={COMPANY_CODE}
              defaultType="All"
              // handleSelectAccount(selectedRowIndex, acc)
              handleCustomerSelect={handleVoucherAccountSelect}
            />
            {/* <ProductListing/> */}
          </Modal>
        )}

        {pdcModalOpen && (
          <Modal
            isOpen={pdcModalOpen}
            onClose={() => setPdcModalOpen(false)}
            title={"Select PDC Account"}
            size="xxl"
            header={true}
          >
            <CreditCustomerList
              companyCode={COMPANY_CODE}
              defaultType="All"
              // handleSelectAccount(selectedRowIndex, acc)
              handleCustomerSelect={handlePDCAccountSelect}
            />
            {/* <ProductListing/> */}
          </Modal>
        )}

        {isChecked && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white max-w-4xl rounded p-4">
              <div className="flex justify-between items-center mb-4">
                <h2 className="font-semibold">Voucher Setup Bill</h2>
                <button
                  type="button"
                  className="ml-2 text-gray-700 hover:text-gray-900"
                  onClick={() => {
                    setIsChecked(false);
                    setIsAccountFocused(false);
                    setSetupBillAccount("");
                  }}
                >
                  <ClearIcon fontSize="small" />
                </button>
              </div>
              <VoucherSetupBill
                companyCode={COMPANY_CODE}
                selectedAccount={setupBillAccount}
                onDataToSend={onDataToRecieve}
                jvType={selectedVoucherType}
              />
            </div>
          </div>
        )}

        {modifyPopup && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white w-[20%] h-[20%] rounded p-4">
              <div className="flex justify-between items-center">
                <h2 className="font-semibold">Modify Voucher</h2>
                <button
                  className="p-1 rounded hover:bg-[#E4E7EB] ml-4"
                  onClick={() => {
                    setModifyPopup(false);
                    setModifyVoucherNo("");
                  }}
                >
                  <ClearIcon fontSize="small" />
                </button>
              </div>
              <div className="flex flex-col justify-center items-center  h-32">
                <input
                  placeholder="Enter Voucher No"
                  value={modifyVoucherNo}
                  onChange={(e) => setModifyVoucherNo(e.target.value)}
                  className="w-full px-3 py-3 text-sm border-none rounded bg-gray-100"
                />

                <button
                  onClick={(e) => {
                    onSubmitVoucherModifyNo(modifyVoucherNo);
                    setModifyVoucherNo("");
                  }}
                  disabled={!modifyVoucherNo.trim()}
                  className={`px-3 py-1 text-white text-sm border rounded mt-4 transition-colors duration-200
    ${
      !modifyVoucherNo.trim()
        ? "bg-gray-400 cursor-not-allowed"
        : "bg-gray-700 hover:bg-black"
    }`}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}

        {deletePopup && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white w-[25%] h-[25%] rounded p-4">
              <div className="flex justify-between items-center">
                <h2 className="font-semibold">Delete Voucher</h2>
                <button
                  className="p-1 rounded hover:bg-[#E4E7EB] ml-4"
                  onClick={() => setDeletePopup(false)}
                >
                  <ClearIcon fontSize="small" />
                </button>
              </div>

              <div className="flex flex-col justify-center items-center h-32 mt-4">
                {/* Delete Icon */}
                <div className="flex justify-center items-center bg-red-100 rounded-full p-3 mb-3">
                  <Trash2 className="w-6 h-6 text-red-600" />
                </div>

                {/* Confirmation Text */}
                <p className="text-sm text-gray-700 text-center">
                  Are you sure you want to delete{" "}
                  <span className="font-semibold">
                    {selectedVoucherType}: {pvnoFromAPI}
                  </span>{" "}
                  ?
                </p>

                {/* Action Buttons */}
                <div className="flex gap-3 mt-8">
                  <button
                    onClick={() => setDeletePopup(false)}
                    className="px-3 py-1 text-sm border rounded bg-gray-100 hover:bg-gray-200"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      onSubmitVoucherDeleteNo(modifyVoucherNo);
                    }}
                    // disabled={!modifyVoucherNo.trim()}
                    className={`bg-red-600 hover:bg-red-700 px-3 py-1 text-white text-sm border rounded transition-colors duration-200`}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {openSavePopup && (
          <div
            className="inset-0 fixed flex justify-center items-center bg-black bg-opacity-50 "
            style={{ zIndex: 150 }}
          >
            <div className="overflow-hidden relative text-left rounded-lg max-w-[290px] shadow-xl bg-white">
              {/* <button
  onClick={handleCloseSnackbar}
    class="absolute top-2 right-2 flex items-center justify-center p-2 bg-white text-black border-2 border-gray-300 text-base font-light w-8 h-8 rounded-md transition ease-in-out duration-300 hover:bg-red-600 hover:border-red-600 hover:text-white"
    type="button"
  >
    ×
  </button> */}
              <div className="p-4 pb-2">
                <div className="flex mx-auto bg-green-100 flex-shrink-0 items-center justify-center w-12 h-12 rounded-full animate-scale-pulse transition ease-in-out duration-600">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M20 7L9.00004 18L3.99994 13"
                        stroke="#000000"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </g>
                  </svg>
                </div>
                <div className="mt-3 text-center">
                  <span className="text-green-700 text-base font-semibold leading-6">
                    {/* {selectedVoucherType}: {savedVNO} Saved Succesfully! */}
                    {selectedVoucherType}: {savedVNO} Saved Succesfully!
                  </span>
                </div>
                <div className="my-3 mx-4">
                  <button
                    className="inline-flex p-2 bg-green-600 text-white text-base leading-6 font-medium justify-center w-full rounded-md shadow-sm"
                    type="button"
                    onClick={handleCloseSnackbar}
                  >
                    OK
                  </button>
                  {/* <button
        class="inline-flex mt-3 p-2 text-gray-800 text-base leading-6 font-medium justify-center w-full rounded-md border border-gray-300 bg-white shadow-sm"
        type="button"
      >
        Track my package
      </button> */}
                </div>
              </div>
            </div>
          </div>
        )}

        {openModifyPopup && (
          <div
            className="inset-0 fixed flex justify-center items-center bg-black bg-opacity-50"
            style={{ zIndex: 150 }}
          >
            <div className="overflow-hidden relative text-left rounded-lg max-w-[290px] shadow-xl bg-white">
              <div className="p-4 pb-2">
                <div className="flex mx-auto bg-yellow-100 flex-shrink-0 items-center justify-center w-12 h-12 rounded-full animate-scale-pulse transition ease-in-out duration-600">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 7L9.00004 18L3.99994 13"
                      stroke="#000000"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="mt-3 text-center">
                  <span className="text-yellow-700 text-base font-semibold leading-6">
                    {selectedVoucherDescription}: {modifiedVNO} Modified
                    Successfully!
                  </span>
                </div>
                <div className="my-3 mx-4">
                  <button
                    className="inline-flex p-2 bg-yellow-600 text-white text-base leading-6 font-medium justify-center w-full rounded-md shadow-sm"
                    type="button"
                    onClick={handleCloseSnackbar}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {showDeleteConfirm && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-sm p-6 text-center">
              <h2 className="text-lg font-semibold mb-4 text-gray-800">
                Confirm Delete
              </h2>
              <p className="text-sm text-gray-600 mb-6">
                Are you sure you want to delete the selected rows? This action
                cannot be undone.
              </p>
              <div className="flex justify-center gap-3">
                <button
                  onClick={() => {
                    // setEntries((prev) => prev.filter((row) => !row.selected));
                    onDelete();
                    setShowDeleteConfirm(false);
                  }}
                  className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
                >
                  Yes, Delete
                </button>
                <button
                  onClick={() => setShowDeleteConfirm(false)}
                  className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 transition"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <MuiAlert
            onClose={handleCloseSnackbar}
            severity="success"
            sx={{ width: "100%" }}
          >
            {selectedVoucherDescription} : {savedVNO} Saved Succesfully!
          </MuiAlert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <MuiAlert
            onClose={handleCloseSnackbar}
            severity="error"
            sx={{ width: "100%" }}
          >
            Failed to save voucher. Please try again!
          </MuiAlert>
        </Snackbar>

        <Snackbar
          open={openErrorModifySnackbar}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <MuiAlert
            onClose={handleCloseSnackbar}
            severity="error"
            sx={{ width: "100%" }}
          >
            Failed to modify voucher. Please try again!
          </MuiAlert>
        </Snackbar>
      </div>
      {/* )} */}
    </>
  );
};

export default Voucher;
